import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
	Typography,
	Grid,
	Stack,
	Accordion,
	AccordionDetails,
	SelectChangeEvent,
	MenuItem,
	TextField,
	Autocomplete,
	Box,
	FormHelperText,
	RadioGroup,
	FormControlLabel,
	Radio,
	// IconButton,
	Avatar,
	Card,
} from '@mui/material';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { PlayArrow } from '@mui/icons-material';
import Paper, { PaperProps } from '@mui/material/Paper';
import Button, { ButtonProps } from '@mui/material/Button';
import './Registration.css';
import RegistrationImg from '../../assets/img/registration/regstration_img.png';
import CustomTextField from '../../components/CustomTextField';
import CustomDropdownField from '../../components/CustomDropdownField';
import CustomCheckBox from '../../components/CustomCheckBox';
import { common } from '../../assets/jss/messages';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reduxstate/index';
import { updateUser } from '../../reduxstate/slices/userSlice';
import { updateCommon } from '../../reduxstate/slices/portalSlice';
import apiQuery from '../../apicall/apiQuery';
import { getCurrentUser, getStrapiData, getHostName, getCmsURL, callApi } from '../../shared';
import Navbar from '../Navbar';
import CustomDropdownMultiSelect from '../../components/CustomDropdownMultiSelect';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Processing from '../../components/Processing';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// @ts-ignore
import match from 'autosuggest-highlight/match';
// @ts-ignore
import parse from 'autosuggest-highlight/parse';

const RegistrationPaper = styled(Paper)<PaperProps>(({ theme }) => ({
	color: '#FFFF',
	height: '90vh !important',
	maxWidth: '100% !important',
	position: 'relative',
	boxShadow: 'none',
}));

const CustomButton = styled(Button)<ButtonProps>(({ theme }) => ({
	color: '#FFFF',
	background: 'linear-gradient(180deg, #0146C7 0%, #022870 100%)',
	borderRadius: '2vmax',
	textTransform: 'none',
	fontFamily: 'PoppinsRegular',
	fontSize: '1vmax',
	justifyContent: 'center',
	width: '10vw',
	'&:hover': {
		background: 'linear-gradient(180deg, #0146C7 0%, #022870 100%)',
	},
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => <MuiAccordionSummary expandIcon={<PlayArrow className='reg_accordian_icon' />} {...props} />)(({ theme }) => ({
	flexDirection: 'row-reverse',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	},
}));

export type DayType = 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';

interface TimeRange {
	startTime: string;
	endTime: string;
}

interface AvailableSlot {
	day: string;
	timing: TimeRange[];
}

export interface Availability {
	availableSlots: AvailableSlot[];
}

// const daysShort: { label: string; value: DayType }[] = [
//   { label: "M", value: "Monday" },
//   { label: "T", value: "Tuesday" },
//   { label: "W", value: "Wednesday" },
//   { label: "T", value: "Thursday" },
//   { label: "F", value: "Friday" },
//   { label: "S", value: "Saturday" },
//   { label: "S", value: "Sunday" },
// ];

interface TutorState {
	data: {
		userId: string;
		profilePicture: string;
		isActive: boolean;
		joinedDate: string;
		relievedDate: string;
		tutorPersonalDetails: {
			tutorFirstName: string;
			tutorLastName: string;
			tutorEmail: string;
			tutorPhCode: string;
			tutorCellNumber: string;
			tutorAddress1: string;
			tutorAddress2: string;
			tutorState: string;
			tutorCountry: string;
			tutorCity: string;
			tutorPostCode: string;
			IPAccess: boolean;
		};
		tutorProfessionalDetails: {
			tutorHighestQualification: string;
			tutorSpecialization: string;
			tutorYearsOfExperience: string;
			tutorSubjectsExpertise: string[];
			tutorTeachingMode: string;
			tutorPosition: string;
		};
		tutorAvailability: Availability;
		tutorPricingDetails: {
			tutorCurrency: string;
			tutorRateFrequency: string;
			tutorRate: number;
			tutorBankDetails: {
				accountHolderName: string;
				bankName: string;
				accountNumber: string;
			};
		};
	};
	error: any;
	errorMessage: any;
}

interface Tutor {
	userId: string;
	tutorPersonalDetails: {
		tutorFirstName: string;
		tutorLastName?: string;
	};
}

interface Student {
	userId: string;
	studentFirstName: string;
	studentLastName: string;
}

const Registration: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const { courseId, workflow, redirectURL } = useSelector((state: RootState) => state.portal);
	const [admin, setAdmin] = useState(false);
	const [isNewUser, setIsNewUser] = React.useState(true);
	const [countryData, setCountryData] = React.useState<any>([]);

	const [schools, setSchools] = React.useState<{ id: number; attributes: { name: string } }[]>([]);

	const [allTutor, setAllTutor] = useState<Tutor[]>([]);
	const [allUser, setAllUser] = useState<Student[]>([]);
	const [tutorTeachingModeOptions, setTutorTeachingModeOptions] = useState<any[]>([]);
	const [tutorSubjectOptions, setTutorSubjectOptions] = useState<any[]>([]);
	const [tutorPositionOptions, setTutorPositionOptions] = useState<any[]>([]);
	// const [rateFrequencyOptions,setRateFrequencyOptions] = useState<any[]>([])

	console.log({ tutorSubjectOptions });

	const techingModeOptions = tutorTeachingModeOptions?.map((item: any) => item.attributes.Name) || [];

	const tutorPositionOption = tutorPositionOptions?.map((item: any) => item.attributes.Name) || [];

	//   const rateFrequencyOption = rateFrequencyOptions?.map(
	//   (item: any) => item.attributes.Name
	// ) || [];

	const tutorSubjectOption =
		tutorSubjectOptions?.map((item: any) => ({
			id: item.id,
			label: item.attributes.Name,
		})) || [];

	const [selectedUser, setSelectedUser] = useState<any>(null);

	const params = new URLSearchParams(window.location.search);
	const redirect_url: any = params.get('redirect_url');
	const toPath: string | null = params.get('to');

	const queryParams = new URLSearchParams(window.location.search);
	const type = queryParams.get('type');
	const isMyProfile = !type;
	console.log({ isMyProfile });

	const [userRole, setUserRole] = useState<any>('');

	const checkAdminUser = async (email: any) => {
		try {
			const contentAPI = await getCmsURL();
			if (contentAPI) {
				const filter = `filters[email][$eqi]=${email}`;
				const url = `${contentAPI}/api/administrators?${filter}`;
				const options: any = {
					method: 'GET',
				};
				const response = await fetch(url, options);
				if (response.status === 200) {
					const data = await response.json();
					return data?.data?.length > 0 || false;
				}
			}
		} catch (error) {
			console.error(error);
		}
		return false;
	};

	const fetchDropdownData = async (endpoint: string, setter: React.Dispatch<React.SetStateAction<any[]>>) => {
		try {
			const contentAPI = await getCmsURL();
			const apiUrl = `${contentAPI}/api/${endpoint}`;

			const response = await fetch(apiUrl, {
				method: 'GET',
			});

			if (!response.ok) {
				console.error(`Error fetching ${endpoint}:`, response.status);
				return false;
			}

			const data = await response.json();

			if (data?.data?.length > 0) {
				setter(data.data);
				return true;
			}

			setter([]);
			return false;
		} catch (error) {
			console.error(`Fetch failed for ${endpoint}:`, error);
			return false;
		}
	};

	const loadAllDropdowns = async () => {
		await Promise.all([
			fetchDropdownData('teaching-modes', setTutorTeachingModeOptions),
			fetchDropdownData('tutor-positions', setTutorPositionOptions),
			fetchDropdownData('subject-of-expertises', setTutorSubjectOptions),
			// fetchDropdownData("rate-frequencies", setRateFrequencyOptions),
		]);
	};

	useEffect(() => {
		let isMounted = true;

		const initialize = async () => {
			try {
				setLoading(true);
				const user = await getCurrentUser();
				if (!user) return;

				const role = type || user.userRole || '';

				setUserRole(role);

				if (isMyProfile) {
					try {
						if (!isMounted) return;
						const endpoint = user.userRole !== 'tutor' ? `registration/${user.id}` : `registration/tutor/${user.id}`;
						console.log({ endpoint });
						const result = await apiQuery(endpoint, {}, 'GET', {});
						console.log({ result });

						setIsNewUser(false);
						dispatch(updateUser({ registerData: result }));
						if (role === 'tutor') {
							console.log({ setNewTutorInfo: user });
							setUpdateTutorInfo(result);
						}
						if (role !== 'tutor') {
							setUpdateUserInfo(result);
						}
					} catch (err) {
						if (!isMounted) return;

						setIsNewUser(true);

						if (role === 'tutor') {
							console.log({ setNewTutorInfo: user });
							setNewTutorInfo(user);
						} else {
							setNewUserInfo(user);
						}
					}
				} else {
					await Promise.allSettled([getAllTutor(), getAllStudent()]);
					setTutorData(initialTutorState);
				}
				const results = await Promise.allSettled([checkRegistration(), GetSchoolData(), fetchCountryData(), loadAllDropdowns()]);

				results.forEach((res, index) => {
					if (res.status === 'rejected') {
						console.error(`API call ${index} failed:`, res.reason);
					}
				});
			} catch (error) {
				console.error('Initialization error:', error);
			} finally {
				if (isMounted) setLoading(false);
			}
		};

		initialize();

		return () => {
			isMounted = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const addClick = () => {
		setSelectedUser(null);
		setIsNewUser(true);
		// setStartTime('09:00')
		// setEndTime('18:00')
		// setIsAddForm(true);
		if (type === 'tutor') {
			setTutorData(initialTutorState);
		} else {
			setUserData(initialUserState);
		}
	};

	const getAllTutor = () => {
		apiQuery(`registration/tutors`, {}, 'GET', {})
			.then((result: any) => {
				const list = Array.isArray(result) ? result : (result?.data ?? result?.tutors ?? []);
				setAllTutor(Array.isArray(list) ? list : []);
			})
			.catch((err) => {
				console.log(err);
				setAllTutor([]);
			});
	};

	const getAllStudent = () => {
		apiQuery(`registration`, {}, 'GET', {})
			.then((result: any) => {
				const list = Array.isArray(result) ? result : (result?.data ?? result?.students ?? []);
				setAllUser(Array.isArray(list) ? list : []);
			})
			.catch((err) => {
				console.log(err);
				setAllUser([]);
			});
	};

	const GetSchoolData = async () => {
		try {
			const data = await getStrapiData('schools?sort=name:asc&pagination[pageSize]=100');
			if (data.length > 0) {
				setSchools(data || []);
			}
		} catch (error) {}
	};
	// const fetchCountryData = async (): Promise<void> => {
	// 	const API_BASE = 'https://api.restcountries.com/countries/v5';
	// 	const API_TOKEN = 'rc_live_7d89fb7fc397460d96301b204fbcb54e';
	// 	const responseFields = 'names.common,codes.alpha_3,flag.url_png,calling_codes';

	// 	// v5 returns either flattened dot-keys (when response_fields is used) or
	// 	// nested objects; read both shapes defensively.
	// 	const pick = (country: any, flatKey: string, nestedPath: string[]) => {
	// 		if (country?.[flatKey] !== undefined) return country[flatKey];
	// 		return nestedPath.reduce((acc: any, key: string) => (acc == null ? acc : acc[key]), country);
	// 	};

	// 	try {
	// 		const limit = 100; // v5 caps page size at 100
	// 		let offset = 0;
	// 		let more = true;
	// 		const all: any[] = [];

	// 		while (more) {
	// 			const response = await fetch(`${API_BASE}?response_fields=${responseFields}&limit=${limit}&offset=${offset}`, {
	// 				headers: {
	// 					Authorization: `Bearer ${API_TOKEN}`,
	// 				},
	// 			});

	// 			if (!response.ok) {
	// 				throw new Error(`Country API error: ${response.status}`);
	// 			}

	// 			const json = await response.json();
	// 			const objects = json?.data?.objects ?? [];
	// 			all.push(...objects);

	// 			more = json?.data?.meta?.more ?? false;
	// 			offset += limit;
	// 		}

	// 		const options = all.map((country: any) => {
	// 			const callingCodes = pick(country, 'calling_codes', ['calling_codes']);
	// 			const firstCode = Array.isArray(callingCodes) ? callingCodes[0] : callingCodes;
	// 			return {
	// 				label: pick(country, 'names.common', ['names', 'common']),
	// 				id: pick(country, 'codes.alpha_3', ['codes', 'alpha_3']),
	// 				flag: pick(country, 'flag.url_png', ['flag', 'url_png']) || '',
	// 				phCode: firstCode ? `+${String(firstCode).replace(/^\+/, '')}` : '',
	// 			};
	// 		});

	// 		setCountryData(options);
	// 	} catch (error) {
	// 		console.warn('Fetch Error: ', error);
	// 	}
	// };

	const fetchCountryData = async (): Promise<void> => {

		try {
			const contentAPI = await getCmsURL();
			if (contentAPI) {
				const path = `${contentAPI}/api/country-lists?populate=flag&pagination[pageSize]=10000&sort=sortOrder:asc`;
				const countryResponse: any = await fetch(path, {
					method: 'GET',
				});
				if (countryResponse.ok) {
					const countryList = await countryResponse.json();
					const options = (countryList?.data || [])
						.filter((country: any) => country?.attributes?.isActive !== false)
						.map((country: any) => {
							const attributes = country.attributes || {};
							const flagUrl = attributes?.flag?.data?.attributes?.url || '';
							const flag = flagUrl ? (flagUrl.startsWith('http') ? flagUrl : `${contentAPI}${flagUrl}`) : '';
							return {
								label: attributes.name || '',
								id: attributes.isoCode3 || country.id,
								flag,
								phCode: '',
							};
						});
					setCountryData(options);
				}
			}
		} catch (error) {
			console.warn('Fetch Error: ', error);
		}
	};

	const checkRegistration = async () => {
		try {
			const user = await getCurrentUser();
			console.log('currentuser', user);
			if (user) {
				const adminData = await checkAdminUser(user.email);
				setAdmin(adminData);
				dispatch(updateUser({ userData: user }));
				// dispatch(
				//   updateCommon({
				//     snackbarDetail: {
				//       open: true,
				//       duration: 5000,
				//       severity: "info",
				//       message: common.registration_info,
				//     },
				//   }),
				// );
				// await Promise.all([checkUserInfo(user), checkTutorInfo(user)]);
			} else {
				navigate('/');
			}
		} catch (error) {
			navigate('/');
		}
	};

	const isEmptyOrSpaces = (value: string | null | undefined) => {
		return value === undefined || value === null || value === '';
	};

	const regex = {
		email: new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@]+(\\.[^<>()\\[\\]\\\\.,;:\\s@]+)*)|(.+))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'),
		number: new RegExp('^[0-9]+$'),
		password: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$'),
	};

	const [expanded, setExpanded] = React.useState<string | false>('panel1');
	console.log('expand', expanded);

	const handleChangeExpand = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		// setExpanded(isExpanded ? panel : false);
		setExpanded(isExpanded ? panel : 'panel1');
	};

	const setNewUserInfo = (user: any) => {
		setUserData({
			...userData,
			data: {
				...userData.data,
				userId: user.id,
				studentFirstName: userRole !== 'tutor' ? user.firstName : '',
				studentLastName: userRole !== 'tutor' ? user.lastName : '',
				studentEmail: userRole !== 'tutor' ? user.email : '',
				studentPhCode: '+1',
				parent1PhCode: '+1',
				studentCountry: 'United States',
				parent1Country: 'United States',
			},
		});
	};

	const setNewTutorInfo = (tutor: any) => {
		setTutorData((prev: any) => ({
			...prev,
			data: {
				...prev.data,
				userId: tutor.id,
				tutorPersonalDetails: {
					...prev.data?.tutorPersonalDetails,
					tutorFirstName: userRole === 'tutor' ? tutor.firstName : '',
					tutorLastName: userRole === 'tutor' ? tutor.lastName : '',
					tutorEmail: userRole === 'tutor' ? tutor.email : '',
					tutorPhCode: '+1',
					tutorCountry: 'United States',
				},
				tutorProfessionalDetails: {
					...prev.data?.tutorProfessionalDetails,
					tutorTeachingMode: 'Online',
				},
				tutorPricingDetails: {
					...prev.data?.tutorPricingDetails,
					tutorCurrency: 'USD',
					tutorRateFrequency: 'Hourly',
				},
			},
		}));
	};

	const setUpdateUserInfo = (user: any) => {
		console.log({ setUpdateUserInfo: user });
		setUserData({
			...userData,
			data: {
				...userData.data,
				userId: user.userId,
				studentFirstName: user.studentFirstName,
				studentLastName: user.studentLastName,
				studentPhCode: user?.studentPhCode || '',
				studentEmail: user?.studentEmail || '',
				studentCellNumber: user.studentCellNumber,
				studentReferredBy: user.studentReferredBy,
				studentAddress1: user.studentAddress1,
				studentAddress2: user.studentAddress2,
				studentState: user.studentState,
				studentCountry: user?.studentCountry || '',
				studentCity: user.studentCity,
				studentPostCode: user.studentPostCode,
				studentGrade: user.studentGrade,
				studentSchool: user.studentSchool,
				allowsms: user.allowsms,
				parent1FirstName: user.parent1FirstName,
				parent1LastName: user.parent1LastName,
				parent1PhCode: user?.parent1PhCode || '',
				parent1CellNumber: user.parent1CellNumber,
				parent1EmailAddress: user.parent1EmailAddress,
				parent1SameAsStudent: user.parent1SameAsStudent,
				parent1Address1: user.parent1Address1,
				parent1Address2: user.parent1Address2,
				parent1City: user.parent1City,
				parent1State: user.parent1State,
				parent1Country: user?.parent1Country || '',
				parent1PostCode: user.parent1PostCode,
				parent2FirstName: user.parent2FirstName,
				parent2LastName: user.parent2LastName,
				parent2PhCode: user.parent2PhCode,
				parent2CellNumber: user.parent2CellNumber,
				parent2EmailAddress: user.parent2EmailAddress,
				parent2SameAsStudent: user.parent2SameAsStudent,
				parent2Address1: user.parent2Address1,
				parent2Address2: user.parent2Address2,
				parent2City: user.parent2City,
				parent2State: user.parent2State,
				parent2Country: user.parent2Country,
				parent2PostCode: user.parent2PostCode,
				notes: user.notes,
				pricing: user.pricing,
				// creditCardType: user.paymentDetails && user.paymentDetails.creditCardType ? user.paymentDetails.creditCardType : '',
				// creditCardNum: user.paymentDetails && user.paymentDetails.creditCardNum ? user.paymentDetails.creditCardNum : '',
				// expirationMonth: user.paymentDetails && user.paymentDetails.expirationMonth ? user.paymentDetails.expirationMonth : '',
				// expirationYear: user.paymentDetails && user.paymentDetails.expirationYear ? user.paymentDetails.expirationYear : '',
				// nameOnAccount: user.paymentDetails && user.paymentDetails.nameOnAccount ? user.paymentDetails.nameOnAccount : '',
				// payCountry: user.paymentDetails && user.paymentDetails.country ? user.paymentDetails.country : '',
			},
			error: {
				studentFirstName: false,
				studentLastName: false,
				studentEmail: false,
				studentPhCode: false,
				studentCellNumber: false,
				studentAddress1: false,
				studentAddress2: false,
				studentState: false,
				studentCountry: false,
				studentCity: false,
				studentPostCode: false,
				studentGrade: false,
				studentSchool: false,
				allowsms: false,
				parent1FirstName: false,
				parent1LastName: false,
				parent1PhCode: false,
				parent1CellNumber: false,
				parent1EmailAddress: false,
				parent1Address1: false,
				parent1Address2: false,
				parent1City: false,
				parent1State: false,
				parent1Country: false,
				parent1PostCode: false,
				parent2PhCode: false,
				parent2CellNumber: false,
				parent2EmailAddress: false,
				// creditCardType: false,
				// creditCardNum: false,
				// expirationMonth: false,
				// expirationYear: false,
				// nameOnAccount: false,
				// payCountry: false,
			},
			errorMessage: {
				required: common.required,
				studentCellNumber: common.required,
				studentEmail: common.required,
				parent1CellNumber: common.required,
				parent1EmailAddress: common.required,
				parent2CellNumber: common.required,
				parent2EmailAddress: common.required,
				// creditCardNum: common.required,
			},
		});
	};

	const initialUserState = {
		data: {
			userId: '',
			studentFirstName: '',
			studentLastName: '',
			studentEmail: '',
			studentPhCode: '',
			studentCellNumber: '',
			studentReferredBy: '',
			studentAddress1: '',
			studentAddress2: '',
			studentState: '',
			studentCountry: '',
			studentCity: '',
			studentPostCode: '',
			studentGrade: '',
			studentSchool: '',
			allowsms: true,
			parent1FirstName: '',
			parent1LastName: '',
			parent1PhCode: '',
			parent1CellNumber: '',
			parent1EmailAddress: '',
			parent1SameAsStudent: false,
			parent1Address1: '',
			parent1Address2: '',
			parent1City: '',
			parent1State: '',
			parent1Country: '',
			parent1PostCode: '',
			parent2FirstName: '',
			parent2LastName: '',
			parent2PhCode: '',
			parent2CellNumber: '',
			parent2EmailAddress: '',
			parent2SameAsStudent: false,
			parent2Address1: '',
			parent2Address2: '',
			parent2City: '',
			parent2State: '',
			parent2Country: '',
			parent2PostCode: '',
			notes: '',
			pricing: '',
			// creditCardType: '',
			// creditCardNum: '',
			// expirationMonth: '',
			// expirationYear: '',
			// nameOnAccount: '',
			// payCountry: '',
		},
		error: {
			studentFirstName: false,
			studentLastName: false,
			studentEmail: false,
			studentPhCode: false,
			studentCellNumber: false,
			studentAddress1: false,
			studentAddress2: false,
			studentState: false,
			studentCountry: false,
			studentCity: false,
			studentPostCode: false,
			studentGrade: false,
			studentSchool: false,
			allowsms: false,
			parent1FirstName: false,
			parent1LastName: false,
			parent1PhCode: false,
			parent1CellNumber: false,
			parent1EmailAddress: false,
			parent1Address1: false,
			parent1Address2: false,
			parent1City: false,
			parent1State: false,
			parent1Country: false,
			parent1PostCode: false,
			parent2PhCode: false,
			parent2CellNumber: false,
			parent2EmailAddress: false,
			// creditCardType: false,
			// creditCardNum: false,
			// expirationMonth: false,
			// expirationYear: false,
			// nameOnAccount: false,
			// payCountry: false,
		},
		errorMessage: {
			required: common.required,
			studentCellNumber: common.required,
			studentEmail: common.required,
			parent1CellNumber: common.required,
			parent1EmailAddress: common.required,
			parent2CellNumber: common.required,
			parent2EmailAddress: common.required,
			// creditCardNum: common.required,
		},
	};

	const [userData, setUserData] = React.useState(initialUserState);
	console.log('userData', userData);

	const initialTutorState = {
		data: {
			userId: '',
			profilePicture: '',
			isActive: true,
			joinedDate: '',
			relievedDate: '',
			tutorPersonalDetails: {
				tutorFirstName: '',
				tutorLastName: '',
				tutorEmail: '',
				tutorPhCode: '',
				tutorCellNumber: '',
				tutorAddress1: '',
				tutorAddress2: '',
				tutorState: '',
				tutorCountry: '',
				tutorCity: '',
				tutorPostCode: '',
				IPAccess: true,
			},
			tutorProfessionalDetails: {
				tutorHighestQualification: '',
				tutorSpecialization: '',
				tutorYearsOfExperience: '',
				tutorSubjectsExpertise: [],
				tutorTeachingMode: '',
				tutorPosition: '',
			},
			tutorAvailability: {
				availableSlots: [
					{ day: 'Monday', timing: [{ startTime: '09:00', endTime: '18:00' }] },
					{ day: 'Tuesday', timing: [{ startTime: '09:00', endTime: '18:00' }] },
					{ day: 'Wednesday', timing: [{ startTime: '09:00', endTime: '18:00' }] },
					{ day: 'Thursday', timing: [{ startTime: '09:00', endTime: '18:00' }] },
					{ day: 'Friday', timing: [{ startTime: '09:00', endTime: '18:00' }] },
				],
			},
			tutorPricingDetails: {
				tutorCurrency: 'USD',
				tutorRateFrequency: '',
				tutorRate: 0,
				tutorBankDetails: {
					accountHolderName: '',
					bankName: '',
					accountNumber: '',
				},
			},
		},
		error: {
			joinedDate: false,
			relievedDate: false,
			tutorPersonalDetails: {
				tutorFirstName: false,
				tutorLastName: false,
				tutorEmail: false,
				tutorPhCode: false,
				tutorCellNumber: false,
				tutorAddress1: false,
				tutorState: false,
				tutorCountry: false,
				tutorCity: false,
				tutorPostCode: false,
			},
			tutorProfessionalDetails: {
				tutorHighestQualification: false,
				tutorSpecialization: false,
				tutorYearsOfExperience: false,
				tutorSubjectsExpertise: false,
				tutorTeachingMode: false,
			},
			// tutorAvailability: {availableSlots : false},
			// tutorPricingDetails: {
			//   tutorRateFrequency: false,
			//   tutorCurrency: false,
			//   tutorBankDetails: {
			//     accountHolderName: false,
			//     bankName: false,
			//     accountNumber: false,
			//   },
			// },
		},
		errorMessage: {
			required: common.required,
			tutorCellNumber: common.required,
			tutorEmail: common.required,
			joinedDate: common.required,
			relievedDate: common.required,
		},
	};

	const [tutorData, setTutorData] = React.useState<TutorState>(initialTutorState);
	console.log({ tutorData });

	const countryError = userRole === 'tutor' ? tutorData?.error?.tutorPersonalDetails?.tutorCountry : userData?.error?.studentCountry;

	const requiredMessage = userRole === 'tutor' ? tutorData?.errorMessage?.required : userData?.errorMessage?.required;

	// const slots = tutorData.data.tutorAvailability.availableSlots;
	// const [startTime, setStartTime] = useState("09:00");
	// const [endTime, setEndTime] = useState("18:00");
	// Scheduling preference required/error state — UI section commented out.
	// const [startTimeError, setStartTimeError] = useState(false);
	// const [endTimeError, setEndTimeError] = useState(false);
	// const [startTimeErrorMessage, setStartTimeErrorMessage] = useState("");
	// const [endTimeErrorMessage, setEndTimeErrorMessage] = useState("");
	// const [showTimeRangeWarning, setShowTimeRangeWarning] = useState(false);
	// const [pendingTimeRange, setPendingTimeRange] = useState<TimeRange | null>(null);
	// const [hasLoadedTutorAvailability, setHasLoadedTutorAvailability] = useState(false);
	// const [activeDay, setActiveDay] = React.useState<string | null>(null);

	// Scheduling preference helpers — UI section commented out.
	// const applyTimeRangeToSlots = (updatedStartTime: string, updatedEndTime: string) => {
	//   setStartTime(updatedStartTime);
	//   setEndTime(updatedEndTime);
	//
	//   setTutorData((prev) => {
	//     const updatedSlots = prev.data.tutorAvailability.availableSlots.map((slot) => ({
	//       ...slot,
	//       timing: [
	//         {
	//           ...(slot.timing?.[0] || {}),
	//           startTime: updatedStartTime,
	//           endTime: updatedEndTime,
	//         },
	//       ],
	//     }));
	//
	//     return {
	//       ...prev,
	//       data: {
	//         ...prev.data,
	//         tutorAvailability: {
	//           ...prev.data.tutorAvailability,
	//           availableSlots: updatedSlots,
	//         },
	//       },
	//     };
	//   });
	// };

	// const confirmAndApplyTimeRange = (updatedStartTime: string, updatedEndTime: string) => {
	//   const previousStartTime = startTime || slots[0]?.timing?.[0]?.startTime || "";
	//   const previousEndTime = endTime || slots[0]?.timing?.[0]?.endTime || "";
	//   const hasBookedTimeRange = slots.some(
	//     (slot) => slot.timing?.[0]?.startTime && slot.timing?.[0]?.endTime,
	//   );
	//
	//   if (
	//     Boolean(selectedUser) &&
	//     hasLoadedTutorAvailability &&
	//     hasBookedTimeRange &&
	//     (updatedStartTime !== previousStartTime || updatedEndTime !== previousEndTime)
	//   ) {
	//     setPendingTimeRange({
	//       startTime: updatedStartTime,
	//       endTime: updatedEndTime,
	//     });
	//     setShowTimeRangeWarning(true);
	//     return;
	//   }
	//
	//   applyTimeRangeToSlots(updatedStartTime, updatedEndTime);
	// };
	//
	// const handleTimeRangeWarningOk = () => {
	//   if (pendingTimeRange) {
	//     applyTimeRangeToSlots(pendingTimeRange.startTime, pendingTimeRange.endTime);
	//   }
	//   setPendingTimeRange(null);
	//   setShowTimeRangeWarning(false);
	// };
	//
	// const handleTimeRangeWarningCancel = () => {
	//   setPendingTimeRange(null);
	//   setShowTimeRangeWarning(false);
	// };

	const setUpdateTutorInfo = (user: any) => {
		console.log({ setUpdateTutorInfo: user });
		if (!user) {
			console.warn('setUpdateTutorInfo called with undefined user');
			return;
		}
		// setStartTime('9:00')

		const hasApiSlots = user?.tutorAvailability?.availableSlots && user.tutorAvailability.availableSlots.length > 0;

		// if (hasApiSlots) {
		//   setHasLoadedTutorAvailability(true);
		//   const firstSlot = user.tutorAvailability.availableSlots[0]?.timing?.[0];
		//   if (firstSlot) {
		//     setStartTime(firstSlot.startTime);
		//     setEndTime(firstSlot.endTime);
		//   }
		// } else {
		//   setHasLoadedTutorAvailability(false);
		// }

		setTutorData(() => ({
			...tutorData,
			data: {
				...tutorData?.data,

				userId: user?.userId ?? '',

				tutorPersonalDetails: {
					...tutorData?.data?.tutorPersonalDetails,
					...user?.tutorPersonalDetails,
				},

				tutorProfessionalDetails: {
					...tutorData?.data?.tutorProfessionalDetails,
					...user?.tutorProfessionalDetails,
				},

				tutorAvailability: {
					...tutorData.data.tutorAvailability,
					availableSlots: hasApiSlots ? user.tutorAvailability.availableSlots : tutorData.data.tutorAvailability.availableSlots,
				},

				tutorPricingDetails: {
					...tutorData?.data?.tutorPricingDetails,
					...user?.tutorPricingDetails,
					tutorBankDetails: {
						...tutorData?.data?.tutorPricingDetails?.tutorBankDetails,
						...user?.tutorPricingDetails?.tutorBankDetails,
					},
				},

				isActive: user?.isActive ?? tutorData?.data?.isActive,
				joinedDate: user?.joinedDate ?? '',
				relievedDate: user?.relievedDate ?? '',
				profilePicture: user?.profilePicture ?? '',
			},
			error: {
				joinedDate: false,
				relievedDate: false,
				tutorPersonalDetails: {
					tutorFirstName: false,
					tutorLastName: false,
					tutorEmail: false,
					tutorPhCode: false,
					tutorCellNumber: false,
					tutorAddress1: false,
					tutorState: false,
					tutorCountry: false,
					tutorCity: false,
					tutorPostCode: false,
				},
				tutorProfessionalDetails: {
					tutorHighestQualification: false,
					tutorSpecialization: false,
					tutorYearsOfExperience: false,
					tutorSubjectsExpertise: false,
					tutorTeachingMode: false,
				},
				// tutorAvailability: {availableSlots : false},
				// tutorPricingDetails: {
				//   tutorRateFrequency: false,
				//   tutorCurrency: false,
				//   tutorBankDetails: {
				//     accountHolderName: false,
				//     bankName: false,
				//     accountNumber: false,
				//   },
				// },
			},
			errorMessage: {
				required: common.required,
				tutorCellNumber: common.required,
				tutorEmail: common.required,
				joinedDate: common.required,
				relievedDate: common.required,
			},
		}));
	};

	const updateNestedState = (prevState: any, name: string, value: any, isError: boolean = false, message: string = '') => {
		const newData = { ...prevState.data };
		const newError = { ...prevState.error };
		const newErrorMessage = { ...prevState.errorMessage };

		const keys = name.split('.');

		let currentData = newData;
		for (let i = 0; i < keys.length - 1; i++) {
			currentData[keys[i]] = { ...currentData[keys[i]] };
			currentData = currentData[keys[i]];
		}
		currentData[keys[keys.length - 1]] = value;

		let currentError = newError;
		for (let i = 0; i < keys.length - 1; i++) {
			currentError[keys[i]] = { ...currentError[keys[i]] };
			currentError = currentError[keys[i]];
		}
		currentError[keys[keys.length - 1]] = isError;

		newErrorMessage[name] = isError ? (isEmptyOrSpaces(value) ? common.required : common.invalid_email) : '';

		return {
			...prevState,
			data: newData,
			error: newError,
			errorMessage: newErrorMessage,
		};
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value, required } = event.target;

		// let isError = false;
		let isEmailValid = false;

		if (required && isEmptyOrSpaces(value)) {
			// isError = true;
		}

		if (name.toLowerCase().includes('email')) {
			if (!isEmptyOrSpaces(value)) {
				isEmailValid = regex.email.test(value);
				if (!isEmailValid) {
					// isError = true;
				}
			} else if (required) {
				// isError = true;
			}
		}

		if (userRole === 'tutor') {
			setTutorData((prevTutorData) => updateNestedState(prevTutorData, name, value));
		} else {
			setUserData((prevUserData) => updateNestedState(prevUserData, name, value));
		}
	};

	const handleCountryChange = (event: React.ChangeEvent<{}>, value: any, country: string) => {
		const name = country;
		const selectedCountry = value?.label || '';

		if (userRole === 'tutor') {
			setTutorData((prev: any) => updateNestedState(prev, name, selectedCountry, false, ''));
		} else {
			setUserData((prev: any) => updateNestedState(prev, name, selectedCountry, false, ''));
		}
	};

	const handleAutocompleteChange = (value: any, field: string, target: 'tutor' | 'user' = 'tutor') => {
		const selectedValue = value || '';

		if (target === 'tutor') {
			setTutorData((prev: any) => updateNestedState(prev, field, selectedValue, false, ''));
		} else {
			setUserData((prev: any) => updateNestedState(prev, field, selectedValue, false, ''));
		}
	};

	const handleSelectChange = (event: SelectChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;

		if (userRole === 'tutor') {
			setTutorData((prev: any) => updateNestedState(prev, name, value, false, ''));
		} else {
			setUserData((prev: any) => updateNestedState(prev, name, value, false, ''));
		}
	};

	const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value === 'true';

		setTutorData((prev) => ({
			...prev,
			data: {
				...prev.data,
				isActive: value,
				relievedDate: '',
			},
		}));
	};

	const handleJoinedDateChange = (newValue: any) => {
		setTutorData((prev: any) => ({
			...prev,
			data: {
				...prev.data,
				joinedDate: newValue ? newValue.format('MM/DD/YYYY') : null,
			},
			error: {
				...prev.error,
				joinedDate: false,
			},
		}));
	};

	// const handleRelievedDateChange = (newValue: any) => {
	//   setTutorData((prev: any) => ({
	//     ...prev,
	//     data: {
	//       ...prev.data,
	//       relievedDate: newValue ? newValue.format("MM/DD/YYYY") : null,
	//     },
	//   }));
	// };

	const handleRelievedDateChange = (newValue: any) => {
		const joinedDate = tutorData?.data?.joinedDate ? dayjs(tutorData.data.joinedDate, 'MM/DD/YYYY') : null;

		if (!newValue) {
			setTutorData((prev: any) => ({
				...prev,
				data: {
					...prev.data,
					relievedDate: '',
				},
				error: {
					...prev.error,
					relievedDate: false,
				},
			}));
			return;
		}

		if (joinedDate && newValue.isBefore(joinedDate, 'day')) {
			setTutorData((prev: any) => ({
				...prev,
				error: {
					...prev.error,
					relievedDate: true,
				},
				errorMessage: {
					...prev.errorMessage,
					relievedDate: 'Relieved date cannot be before Joined date',
				},
			}));
			return;
		}

		setTutorData((prev: any) => ({
			...prev,
			data: {
				...prev.data,
				relievedDate: newValue.format('MM/DD/YYYY'),
			},
			error: {
				...prev.error,
				relievedDate: false,
			},
		}));
	};

	const handleNotification = (event: React.ChangeEvent<HTMLInputElement>) => {
		const name = event.target.name;
		const checked = event.target.checked;
		setUserData({
			...userData,
			data: {
				...userData.data,
				[name]: checked,
			},
		});
	};

	const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = event.target;

		const updateState = (prevState: any) => {
			const newData = { ...prevState.data };
			const newError = { ...prevState.error };

			const keys = name.split('.');

			let currentData = newData;
			for (let i = 0; i < keys.length - 1; i++) {
				currentData[keys[i]] = { ...currentData[keys[i]] };
				currentData = currentData[keys[i]];
			}
			currentData[keys[keys.length - 1]] = checked;

			if (checked && (name === 'parent1SameAsStudent' || name === 'parent2SameAsStudent')) {
				if (name === 'parent1SameAsStudent') {
					newData.parent1Address1 = newData.studentAddress1;
					newData.parent1Address2 = newData.studentAddress2;
					newData.parent1City = newData.studentCity;
					newData.parent1State = newData.studentState;
					newData.parent1Country = newData.studentCountry;
					newData.parent1PostCode = newData.studentPostCode;
				}
				if (name === 'parent2SameAsStudent') {
					newData.parent2Address1 = newData.studentAddress1;
					newData.parent2Address2 = newData.studentAddress2;
					newData.parent2City = newData.studentCity;
					newData.parent2State = newData.studentState;
					newData.parent2Country = newData.studentCountry;
					newData.parent2PostCode = newData.studentPostCode;
				}
			}

			let currentError = newError;
			for (let i = 0; i < keys.length - 1; i++) {
				currentError[keys[i]] = { ...currentError[keys[i]] };
				currentError = currentError[keys[i]];
			}
			currentError[keys[keys.length - 1]] = false;

			return {
				...prevState,
				data: newData,
				error: newError,
			};
		};

		if (userRole === 'tutor') {
			setTutorData((prev: any) => updateState(prev));
		} else {
			setUserData((prev: any) => updateState(prev));
		}
	};

	// const copyAddressForParent1 = () => {
	//   setUserData({
	//     ...userData,
	//     data: {
	//       ...userData.data,
	//       parent1SameAsStudent: true,
	//       parent1Address1: userData.data.studentAddress1,
	//       parent1Address2: userData.data.studentAddress2,
	//       parent1City: userData.data.studentCity,
	//       parent1State: userData.data.studentState,
	//       parent1Country: userData.data.studentCountry,
	//       parent1PostCode: userData.data.studentPostCode,
	//     },
	//   });
	// };

	// const copyAddressForParent2 = () => {
	//   setUserData({
	//     ...userData,
	//     data: {
	//       ...userData.data,
	//       parent2SameAsStudent: true,
	//       parent2Address1: userData.data.studentAddress1,
	//       parent2Address2: userData.data.studentAddress2,
	//       parent2City: userData.data.studentCity,
	//       parent2State: userData.data.studentState,
	//       parent2Country: userData.data.studentCountry,
	//       parent2PostCode: userData.data.studentPostCode,
	//     },
	//   });
	// };

	const handleChangeNumber = (event: React.ChangeEvent<HTMLInputElement>, type?: string) => {
		const name = event.target.name;
		let only_number = event.target.value.replace(/[^0-9]/g, '');
		let final_number: any;
		if (type === 'phone') {
			only_number = only_number.length > 11 ? only_number.substring(0, 11) : only_number;

			if (only_number.length < 10) {
				final_number = only_number;
			} else if (only_number.length === 10) {
				final_number = only_number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
			} else if (only_number.length === 11) {
				final_number = only_number.replace(/(\d{3})(\d{3})(\d{5})/, '$1-$2-$3');
			}
		} else {
			final_number = only_number;
		}

		// if (name === 'creditCardNum') {
		// 	only_number = only_number.length > 20 ? only_number.substring(0, 20) : only_number;
		// 	final_number = only_number;
		// }

		let isError = false;
		let isPhoneNum = false;
		if (type === 'phone') {
			if (event.target.required) {
				isPhoneNum = regex.number.test(final_number);
				if (isEmptyOrSpaces(final_number) || isPhoneNum) {
					isError = true;
				}
			} else if (!isEmptyOrSpaces(final_number)) {
				isPhoneNum = regex.number.test(final_number);
				if (isPhoneNum) {
					isError = true;
				}
			}
		} else {
			if (event.target.required && isEmptyOrSpaces(final_number)) {
				isError = true;
			}
		}

		const updateState = (prevState: any) => {
			const newData = { ...prevState.data };
			const newError = { ...prevState.error };
			const newErrorMessage = { ...prevState.errorMessage };

			const keys = name.split('.');

			let currentData = newData;
			for (let i = 0; i < keys.length - 1; i++) {
				currentData[keys[i]] = { ...currentData[keys[i]] };
				currentData = currentData[keys[i]];
			}
			currentData[keys[keys.length - 1]] = final_number;

			let currentError = newError;
			for (let i = 0; i < keys.length - 1; i++) {
				currentError[keys[i]] = { ...currentError[keys[i]] };
				currentError = currentError[keys[i]];
			}
			currentError[keys[keys.length - 1]] = isError;

			newErrorMessage[name] = isError ? (isPhoneNum ? common.invalid_phone : common.required) : '';

			return {
				...prevState,
				data: newData,
				error: newError,
				errorMessage: newErrorMessage,
			};
		};

		if (userRole === 'tutor') {
			setTutorData((prev: any) => updateState(prev));
		} else {
			setUserData((prev: any) => updateState(prev));
		}
	};

	const handleChangeYearsOfExperience = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
		const value = event.target.value;

		if (!/^\d*\.?\d*$/.test(value)) {
			return;
		}

		setTutorData((prev) => ({
			...prev,
			data: {
				...prev.data,
				tutorProfessionalDetails: {
					...prev.data.tutorProfessionalDetails,
					[field]: value,
				},
			},
			error: {
				...prev.error,
				tutorProfessionalDetails: {
					...prev.error.tutorProfessionalDetails,
					[field]: value ? false : true,
				},
			},
		}));
	};

	// const handleChangeRate = (event: React.ChangeEvent<HTMLInputElement>) => {
	//   const value = event.target.value;

	//   if (!/^\d*\.?\d*$/.test(value)) return;

	//   setTutorData((prev) => ({
	//     ...prev,
	//     data: {
	//       ...prev.data,
	//       tutorPricingDetails: {
	//         ...prev.data.tutorPricingDetails,
	//         tutorRate: value === "" ? 0 : parseFloat(value),
	//       },
	//     },
	//   }));
	// };

	const handleManage = () => {
		let redirect_url = `${window.location.protocol}//dashboard.${getHostName()}`;
		// let redirect_url = `http://localhost:3006`;
		window.location.replace(redirect_url);
	};

	//   const saveUserData = async (event: React.MouseEvent<HTMLButtonElement>) => {
	//     event.preventDefault();
	//     const isVaildAll = validateAll();
	//     if (isVaildAll) {
	//       updateUserData(userData.data);
	//     }
	//   };

	// const updateUserData = (user: any) => {
	//   const body = {
	//     firstName: user.studentFirstName,
	//     lastName: user.studentLastName,
	//   };
	//   apiQuery(`users/${user.userId}`, {}, "PUT", body)
	//     .then((result: any) => {
	//       if (isNewUser) {
	//         createUserDetail(userData.data);
	//       } else {
	//         updateUserDetail(userData.data);
	//       }
	//     })
	//     .catch((error: any) => {});
	// };

	const updateUserData = async (user: any) => {
		try {
			// const body = {
			//   firstName: user.studentFirstName,
			//   lastName: user.studentLastName,
			// };

			// if (user.userId) {
			//   await apiQuery(`users/${user.userId}`, {}, "PUT", body);
			// }

			if (isNewUser || !user.userId) {
				await createUserDetail(userData.data);
			} else {
				await updateUserDetail(userData.data);
			}
		} catch (error: any) {
			FailLogin(error);
		}
	};

	const removeMongoIds = (obj: any): any => {
		if (Array.isArray(obj)) {
			return obj.map(removeMongoIds);
		} else if (obj !== null && typeof obj === 'object') {
			return Object.keys(obj).reduce((acc: any, key) => {
				if (key !== '_id') {
					acc[key] = removeMongoIds(obj[key]);
				}
				return acc;
			}, {});
		}
		return obj;
	};

	const updateTutorData = async (user: any) => {
		try {
			// const body = {
			//   firstName: user.tutorFirstName,
			//   lastName: user.tutorLastName,
			// };

			// if (user.userId) {
			//   await apiQuery(`users/${user.userId}`, {}, "PUT", body);
			// }

			if (isNewUser || !user.userId) {
				await createTutorDetail(tutorData.data);
			} else {
				const tutorUpdatedData = removeMongoIds(tutorData.data);

				await updateTutorDetail(tutorUpdatedData);
			}
		} catch (error: any) {
			FailLogin(error);
		}
	};

	const createUserDetail = async (user: any) => {
		try {
			// let createUser = {
			// 	...user,
			// 	paymentDetails: {
			// 		// creditCardType: user.creditCardType,
			// 		creditCardNum: user.creditCardNum,
			// 		expirationMonth: user.expirationMonth,
			// 		expirationYear: user.expirationYear,
			// 		nameOnAccount: user.nameOnAccount,
			// 		country: user.payCountry,
			// 	},
			// };
			const endpoint = admin && type === 'student' ? 'registration/student' : 'registration';

			const result = (await apiQuery(endpoint, {}, 'POST', user)) as any;

			if (admin && type === 'student') {
				setAllUser((prev) => [...prev, result]);
			}

			dispatch(updateUser({ registerData: result }));
			dispatch(
				updateCommon({
					snackbarDetail: {
						open: true,
						duration: 5000,
						severity: 'success',
						message: common.save_success,
					},
				}),
			);

			sendSuccessMail();

			if (type === 'student') {
				setUserData(initialUserState);
			}

			if (type !== 'student') {
				if (!isEmptyOrSpaces(redirect_url)) {
					window.location.replace(decodeURIComponent(redirect_url));
				} else if ((workflow === 'enroll' || workflow === 'diagnostic' || workflow === 'fulllength') && !isEmptyOrSpaces(redirectURL)) {
					window.location.replace(redirectURL);
				} else {
					if (isEmptyOrSpaces(courseId) && type !== 'student') {
						handleManage();
					} else {
						navigate('/enroll?from=portal&code=' + courseId);
					}
				}
				if (toPath === 'dashboard') handleManage();
			}
		} catch (error) {
			FailLogin(error);
		}
	};

	const updateUserDetail = async (user: any) => {
		try {
			// let updatedUser = {
			// 	...user,
			// 	paymentDetails: {
			// 		// creditCardType: user.creditCardType,
			// 		creditCardNum: user.creditCardNum,
			// 		expirationMonth: String(user.expirationMonth).padStart(2, '0'),
			// 		expirationYear: user.expirationYear,
			// 		nameOnAccount: user.nameOnAccount,
			// 		country: user.payCountry,
			// 	},
			// };

			const result = await apiQuery(`registration/${user.userId}`, {}, 'PUT', user);

			setIsNewUser(false);
			dispatch(updateUser({ registerData: result }));
			dispatch(
				updateCommon({
					snackbarDetail: {
						open: true,
						duration: 5000,
						severity: 'success',
						message: common.update_success,
					},
				}),
			);

			if (type !== 'student') {
				if (!isEmptyOrSpaces(redirect_url)) {
					window.location.replace(decodeURIComponent(redirect_url));
				} else if (workflow === 'enroll' && !isEmptyOrSpaces(redirectURL)) {
					window.location.replace(redirectURL);
				} else {
					if (isEmptyOrSpaces(courseId)) {
						navigate('/');
					} else {
						navigate('/enroll?from=portal&code=' + courseId);
					}
				}
			}
		} catch (error: any) {
			FailLogin(error);
			// throw error;
		}
	};

	const createTutorDetail = async (tutor: any) => {
		try {
			const result = (await apiQuery('registration/tutor', {}, 'POST', tutor)) as Tutor;

			setAllTutor((prev) => [...prev, result]);

			dispatch(updateUser({ registerData: result }));

			dispatch(
				updateCommon({
					snackbarDetail: {
						open: true,
						duration: 5000,
						severity: 'success',
						message: common.save_success,
					},
				}),
			);

			// await sendSuccessMailTutor();
			// setStartTimeError(false)
			// setStartTimeErrorMessage('')
			// setEndTimeError(false);
			// setEndTimeErrorMessage('')

			if (type === 'tutor') {
				await setTutorData(initialTutorState);
			}

			if (!isEmptyOrSpaces(redirect_url)) {
				window.location.replace(decodeURIComponent(redirect_url));
				return;
			}

			if (toPath === 'dashboard') {
				handleManage();
			}
		} catch (error: any) {
			FailLogin(error);
		}
	};

	const updateTutorDetail = async (user: any) => {
		try {
			const result = await apiQuery(`registration/tutor/${user.userId}`, {}, 'PUT', user);

			dispatch(updateUser({ registerData: result }));
			dispatch(
				updateCommon({
					snackbarDetail: {
						open: true,
						duration: 5000,
						severity: 'success',
						message: common.update_success,
					},
				}),
			);
			// setStartTimeError(false)
			// setStartTimeErrorMessage('')
			// setEndTimeError(false);
			// setEndTimeErrorMessage('')
		} catch (error) {
			FailLogin(error);
		}
	};

	const sendSuccessMail = () => {
		let mailData: any = userData.data;
		const school = (schools || [])?.find((a: any) => a.id === userData.data.studentSchool)?.attributes?.name;
		const studentCellNumber = userData?.data?.studentPhCode + userData?.data?.studentCellNumber;
		const parent1CellNumber = userData?.data?.parent1PhCode + userData?.data?.parent1CellNumber;
		const parent2CellNumber = userData?.data?.parent2PhCode + userData?.data?.parent2CellNumber;
		mailData['studentSchoolFull'] = school;
		mailData['studentCellNumber'] = studentCellNumber;
		mailData['parent1CellNumber'] = parent1CellNumber;
		mailData['parent2CellNumber'] = parent2CellNumber;
		callApi(`auth/registrationsuccess`, 'POST', mailData);
	};

	// const sendSuccessMailTutor = () => {
	//   let mailData: any = tutorData.data;

	//   callApi(`auth/registrationsuccess`, "POST", mailData);
	// };

	// const FailLogin = (error: any) => {
	//   console.log({error})
	//   if(error.status === 409){
	//     dispatch(
	//     updateCommon({
	//       snackbarDetail: {
	//         open: true,
	//         duration: 5000,
	//         severity: "error",
	//         message: error.reason.message || 'Email Already Exists',
	//       },
	//     }),
	//   );
	//   } else{

	//     dispatch(
	//       updateCommon({
	//         snackbarDetail: {
	//           open: true,
	//           duration: 5000,
	//           severity: "error",
	//           message: common.save_error,
	//         },
	//       }),
	//     );
	//   }
	//     console.error("Login failed:", error);
	// };

	const FailLogin = (err: any) => {
		console.log('FULL ERR :', err);

		const status = err?.status;
		const message = err?.reason?.message || err?.message || common.save_error;

		if (Number(status) === 409) {
			dispatch(
				updateCommon({
					snackbarDetail: {
						open: true,
						duration: 5000,
						severity: 'error',
						message,
					},
				}),
			);
		} else {
			dispatch(
				updateCommon({
					snackbarDetail: {
						open: true,
						duration: 5000,
						severity: 'error',
						message: common.save_error,
					},
				}),
			);
		}

		console.error('Login failed:', err);
	};

	const validateAll = () => {
		let errorStudentTab = false;
		let errorParent1Tab = false;
		let errorParent2Tab = false;
		// let errorParent3Tab = false;
		let isValidData = true;
		let studentFirstName = false;
		let studentLastName = false;
		let studentEmail = false;
		let studentPhCode = false;
		let studentCellNumber = false;
		let studentAddress1 = false;
		let studentAddress2 = false;
		let studentState = false;
		let studentCountry = false;
		let studentCity = false;
		let studentPostCode = false;
		let studentGrade = false;
		let studentSchool = false;
		let parent1FirstName = false;
		let parent1LastName = false;
		let parent1PhCode = false;
		let parent1CellNumber = false;
		let parent1EmailAddress = false;
		let parent1Address1 = false;
		let parent1Address2 = false;
		let parent1City = false;
		let parent1State = false;
		let parent1Country = false;
		let parent1PostCode = false;
		let parent2PhCode = false;
		let parent2CellNumber = false;
		let parent2EmailAddress = false;
		// let creditCardNum = false;

		if (isEmptyOrSpaces(userData.data.studentFirstName)) {
			studentFirstName = true;
		}
		if (isEmptyOrSpaces(userData.data.studentLastName)) {
			studentLastName = true;
		}

		const sEmailTest = regex.email.test(userData.data.studentEmail);
		if (isEmptyOrSpaces(userData.data.studentEmail) || !sEmailTest) {
			studentEmail = true;
		}
		const snumberTest = regex.number.test(userData.data.studentCellNumber);
		if (isEmptyOrSpaces(userData.data.studentCellNumber) || snumberTest) {
			studentCellNumber = true;
		}
		if (isEmptyOrSpaces(userData.data.studentPostCode)) {
			studentPostCode = true;
		}
		if (isEmptyOrSpaces(userData.data.studentAddress1)) {
			studentAddress1 = true;
		}
		if (isEmptyOrSpaces(userData.data.studentState)) {
			studentState = true;
		}
		if (isEmptyOrSpaces(userData.data.studentCountry)) {
			studentCountry = true;
		}
		if (isEmptyOrSpaces(userData.data.studentCity)) {
			studentCity = true;
		}
		if (isEmptyOrSpaces(userData.data.studentGrade)) {
			studentGrade = true;
		}
		if (isEmptyOrSpaces(userData.data.studentSchool)) {
			studentSchool = true;
		}

		if (
			studentFirstName ||
			studentLastName ||
			studentEmail ||
			studentCellNumber ||
			studentPostCode ||
			studentAddress1 ||
			studentState ||
			studentCountry ||
			// studentCountry ||
			studentCity ||
			studentSchool
		) {
			errorStudentTab = true;
		}

		if (isEmptyOrSpaces(userData.data.parent1FirstName)) {
			parent1FirstName = true;
		}
		if (isEmptyOrSpaces(userData.data.parent1LastName)) {
			parent1LastName = true;
		}
		const p1numberTest = regex.number.test(userData.data.parent1CellNumber);
		if (isEmptyOrSpaces(userData.data.parent1CellNumber) || p1numberTest) {
			parent1CellNumber = true;
		}
		const p1EmailTest = regex.email.test(userData.data.parent1EmailAddress);
		if (isEmptyOrSpaces(userData.data.parent1EmailAddress) || !p1EmailTest) {
			parent1EmailAddress = true;
		}
		if (isEmptyOrSpaces(userData.data.parent1PostCode)) {
			parent1PostCode = true;
		}
		if (isEmptyOrSpaces(userData.data.parent1Address1)) {
			parent1Address1 = true;
		}
		if (isEmptyOrSpaces(userData.data.parent1City)) {
			parent1City = true;
		}
		if (isEmptyOrSpaces(userData.data.parent1State)) {
			parent1State = true;
		}
		if (isEmptyOrSpaces(userData.data.parent1Country)) {
			parent1Country = true;
		}

		if (parent1FirstName || parent1LastName || parent1CellNumber || parent1EmailAddress || parent1PostCode || parent1Address1 || parent1State || parent1City || parent1Country) {
			errorParent1Tab = true;
		}

		const p2numberTest = regex.number.test(userData.data.parent2CellNumber);
		if (!isEmptyOrSpaces(userData.data.parent2CellNumber) && p2numberTest) {
			parent2CellNumber = true;
		}
		const p2EmailTest = regex.email.test(userData.data.parent2EmailAddress);
		if (!isEmptyOrSpaces(userData.data.parent2EmailAddress) && !p2EmailTest) {
			parent2EmailAddress = true;
		}
		// const creditCardTest = !/^\d{10,20}$/.test(userData.data.creditCardNum);
		// if (!isEmptyOrSpaces(userData.data.creditCardNum) && creditCardTest) {
		// 	creditCardNum = true;
		// }

		if (parent2CellNumber || parent2EmailAddress) {
			errorParent2Tab = true;
		}

		// if (creditCardNum) {
		// 	errorParent3Tab = true;
		// }

		if (errorStudentTab || errorParent1Tab || errorParent2Tab) {
			isValidData = false;
		}

		if (errorStudentTab) {
			setExpanded('panel1');
		} else if (errorParent1Tab) {
			setExpanded('panel2');
		} else if (errorParent2Tab) {
			setExpanded('panel3');
		}
		// else if (errorParent3Tab) {
		// 	setExpanded('panel4');
		// }

		setUserData({
			...userData,
			error: {
				...userData.error,
				studentFirstName: studentFirstName,
				studentLastName: studentLastName,
				studentEmail: studentEmail,
				studentPhCode: studentPhCode,
				studentCellNumber: studentCellNumber,
				studentAddress1: studentAddress1,
				studentAddress2: studentAddress2,
				studentState: studentState,
				studentCountry: studentCountry,
				studentCity: studentCity,
				studentPostCode: studentPostCode,
				studentGrade: studentGrade,
				studentSchool: studentSchool,
				parent1FirstName: parent1FirstName,
				parent1LastName: parent1LastName,
				parent1PhCode: parent1PhCode,
				parent1CellNumber: parent1CellNumber,
				parent1EmailAddress: parent1EmailAddress,
				parent1Address1: parent1Address1,
				parent1Address2: parent1Address2,
				parent1City: parent1City,
				parent1State: parent1State,
				parent1Country: parent1Country,
				parent1PostCode: parent1PostCode,
				parent2PhCode: parent2PhCode,
				parent2CellNumber: parent2CellNumber,
				parent2EmailAddress: parent2EmailAddress,
				// creditCardNum: creditCardNum,
			},
			errorMessage: {
				...userData.errorMessage,
				studentCellNumber: studentCellNumber ? (snumberTest ? common.invalid_phone : common.required) : common.required,
				studentEmail: studentEmail ? (isEmptyOrSpaces(userData.data.studentEmail) ? common.required : common.invalid_email) : common.required,
				parent1CellNumber: parent1CellNumber ? (p1numberTest ? common.invalid_phone : common.required) : common.required,
				parent1EmailAddress: parent1EmailAddress ? (isEmptyOrSpaces(userData.data.parent1EmailAddress) ? common.required : common.invalid_email) : common.required,
				parent2CellNumber: parent2CellNumber ? (p2numberTest ? common.invalid_phone : common.required) : common.required,
				parent2EmailAddress: parent2EmailAddress ? (isEmptyOrSpaces(userData.data.parent2EmailAddress) ? common.required : common.invalid_email) : common.required,
				// creditCardNum: common.invalid_creditcard_number,
			},
		});

		return isValidData;
	};

	const validateAllTutor = () => {
		let errorTutorPersonalDetailsTab = false;
		let errorTutorProfessionalDetailsTab = false;
		// let errorAvailabilityTab = false;
		// let errorPricingTab = false;
		// let errorParent3Tab = false;
		let isValidData = true;
		let joinedDate = false;
		let relievedDate = false;
		let tutorFirstName = false;
		let tutorLastName = false;
		let tutorEmail = false;
		let tutorPhCode = false;
		let tutorCellNumber = false;
		let tutorAddress1 = false;
		// let tutorAddress2 = false;
		let tutorState = false;
		let tutorCountry = false;
		let tutorCity = false;
		let tutorPostCode = false;
		let tutorHighestQualification = false;
		let tutorSpecialization = false;
		let tutorYearsOfExperience = false;
		// let availableSlots = false;
		// let tutorSubjectExpertise = false;
		let tutorTeachingMode = false;
		let tutorPosition = false;
		// let tutorCurrency = false;
		// let tutorRateFrequency = false;
		// let tutorRate = false;
		// let accountHolderName = false;
		// let bankName = false;
		// let accountNumber = false;

		if (isEmptyOrSpaces(tutorData.data.joinedDate)) {
			joinedDate = true;
		}

		if (!tutorData.data.isActive) {
			const relieved = tutorData.data.relievedDate;
			const joined = tutorData.data.joinedDate;

			const relievedObj = dayjs(relieved, 'MM/DD/YYYY', true);
			const joinedObj = dayjs(joined, 'MM/DD/YYYY', true);

			if (isEmptyOrSpaces(relieved)) {
				relievedDate = true;
			} else if (!relievedObj.isValid()) {
				relievedDate = true;
			} else if (joinedObj.isValid() && relievedObj.isBefore(joinedObj, 'day')) {
				relievedDate = true;
			}
		}

		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorFirstName)) {
			tutorFirstName = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorLastName)) {
			tutorLastName = true;
		}
		const email = tutorData.data.tutorPersonalDetails.tutorEmail;
		const tEmailTest = regex.email.test(email);

		if (isEmptyOrSpaces(email)) {
			tutorEmail = true;
		} else if (!tEmailTest) {
			tutorEmail = true;
		} else {
			tutorEmail = false;
		}
		// if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorEmail)) {
		//   tutorEmail = true;
		// }
		const tnumberTest = regex.number.test(tutorData.data.tutorPersonalDetails.tutorCellNumber);
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorCellNumber) || tnumberTest) {
			tutorCellNumber = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorPostCode)) {
			tutorPostCode = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorAddress1)) {
			tutorAddress1 = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorState)) {
			tutorState = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorCountry)) {
			tutorCountry = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorCity)) {
			tutorCity = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorPersonalDetails.tutorPostCode)) {
			tutorPostCode = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorProfessionalDetails.tutorHighestQualification)) {
			tutorHighestQualification = true;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorProfessionalDetails.tutorSpecialization)) {
			tutorSpecialization = false;
		}
		if (isEmptyOrSpaces(tutorData.data.tutorProfessionalDetails.tutorYearsOfExperience)) {
			tutorYearsOfExperience = true;
		}
		// if (
		//   isEmptyOrSpaces(
		//     userData.data.tutorProfessionalDetails.tutorSubjectsExpertise,
		//   )
		// ) {
		//   tutorSubjectExpertise = true;
		// }
		if (isEmptyOrSpaces(tutorData.data.tutorProfessionalDetails.tutorTeachingMode)) {
			tutorTeachingMode = true;
		}

		if (isEmptyOrSpaces(tutorData.data.tutorProfessionalDetails.tutorPosition)) {
			tutorPosition = true;
		}

		// Scheduling preference section is commented out in UI — skip required validation.
		// if (
		//   !tutorData.data.tutorAvailability?.availableSlots?.length
		// ) {
		//   availableSlots = true;
		// }
		// if (availableSlots) {
		//   errorAvailabilityTab = true;
		// }

		// Pricing & scheduling sections are commented out in UI — skip required validation.
		// if (isEmptyOrSpaces(tutorData.data.tutorPricingDetails.tutorCurrency)) {
		//   tutorCurrency = true;
		// }
		// if (
		//   isEmptyOrSpaces(tutorData.data.tutorPricingDetails.tutorRateFrequency)
		// ) {
		//   tutorRateFrequency = true;
		// }
		// if (
		//   isEmptyOrSpaces(
		//     tutorData.data.tutorPricingDetails.tutorBankDetails.accountHolderName,
		//   )
		// ) {
		//   accountHolderName = true;
		// }
		// if (
		//   isEmptyOrSpaces(
		//     tutorData.data.tutorPricingDetails.tutorBankDetails.bankName,
		//   )
		// ) {
		//   bankName = true;
		// }
		// if (
		//   isEmptyOrSpaces(
		//     tutorData.data.tutorPricingDetails.tutorBankDetails.accountNumber,
		//   )
		// ) {
		//   accountNumber = true;
		// }

		if (joinedDate || relievedDate || tutorFirstName || tutorLastName || tutorEmail || tutorPhCode || tutorCellNumber || tutorAddress1 || tutorState || tutorCountry || tutorCity || tutorPostCode) {
			errorTutorPersonalDetailsTab = true;
		}

		if (tutorHighestQualification || tutorSpecialization || tutorYearsOfExperience || tutorTeachingMode || tutorPosition) {
			errorTutorProfessionalDetailsTab = true;
		}

		// if (availableSlots) {
		//   errorAvailabilityTab = true;
		// }

		// if (
		//   tutorRate ||
		//   tutorCurrency ||
		//   tutorRateFrequency||
		//   accountHolderName ||
		//   bankName ||
		//   accountNumber
		// ) {
		//   errorPricingTab = true;
		// }

		if (
			errorTutorPersonalDetailsTab ||
			errorTutorProfessionalDetailsTab
			// errorAvailabilityTab ||
			// errorPricingTab
		) {
			isValidData = false;
		}

		if (errorTutorPersonalDetailsTab) {
			setExpanded('panel1');
		} else if (errorTutorProfessionalDetailsTab) {
			setExpanded('panel4');
		}
		//   else if (errorAvailabilityTab) {
		//     setExpanded("panel5");
		//   }
		// else if (errorPricingTab) {
		//   setExpanded("panel6");
		// }
		// else if (errorParent3Tab) {
		// 	setExpanded('panel4');
		// }

		setTutorData({
			...tutorData,
			error: {
				...tutorData.error,
				joinedDate: joinedDate,
				relievedDate: relievedDate,
				tutorPersonalDetails: {
					...tutorData.error.tutorPersonalDetails,
					tutorFirstName: tutorFirstName,
					tutorLastName: tutorLastName,
					tutorEmail: tutorEmail,
					tutorPhCode: tutorPhCode,
					tutorCellNumber: tutorCellNumber,
					tutorAddress1: tutorAddress1,
					tutorState: tutorState,
					tutorCountry: tutorCountry,
					tutorCity: tutorCity,
					tutorPostCode: tutorPostCode,
				},
				tutorProfessionalDetails: {
					...tutorData.error.tutorProfessionalDetails,
					tutorHighestQualification: tutorHighestQualification,
					tutorSpecialization: tutorSpecialization,
					tutorYearsOfExperience: tutorYearsOfExperience,
					tutorTeachingMode: tutorTeachingMode,
					tutorPosition: tutorPosition,
				},
				// tutorAvailability: {
				//   availableSlots: availableSlots,
				// },
				// tutorPricingDetails: {
				//   ...tutorData.error.tutorPricingDetails,
				//   tutorCurrency: tutorCurrency,
				//   tutorRateFrequency:tutorRateFrequency,
				//   tutorBankDetails: {
				//     accountHolderName: accountHolderName,
				//     bankName: bankName,
				//     accountNumber: accountNumber,
				//   },
				// },
			},
			errorMessage: {
				...tutorData.errorMessage,
				joinedDate: joinedDate ? common.required : '',
				relievedDate: relievedDate ? 'This field is required & Relieved date cannot be before Joined date' : '',
				tutorCellNumber: tutorCellNumber ? (tnumberTest ? common.invalid_phone : common.required) : common.required,

				tutorEmail: tutorEmail ? (isEmptyOrSpaces(email) ? common.required : common.invalid_email) : '',
			},
		});

		return isValidData;
	};

	// const saveUserData = async (event: React.MouseEvent<HTMLButtonElement>) => {
	//   event.preventDefault();
	//   if (userRole === 'tutor') {
	//     const isVaildAllTutor = validateAllTutor();
	//     if (isVaildAllTutor) {
	//       updateTutorData(tutorData.data);

	//       console.log("Tutor data is valid. Proceed with submission.", tutorData);
	//     }
	//   } else {
	//     const isVaildAll = validateAll();
	//     if (isVaildAll) {
	//       updateUserData(userData.data);
	//     }
	//   }
	// };

	const withLoading = async (callback: () => Promise<void>) => {
		try {
			setLoading(true);
			await callback();
		} catch (error) {
			console.error(error);
			throw error; // optional: rethrow if parent needs it
		} finally {
			setLoading(false);
		}
	};

	const saveUserData = async (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();

		await withLoading(async () => {
			if (userRole === 'tutor') {
				const isValidAllTutor = validateAllTutor();
				if (!isValidAllTutor) return;

				await updateTutorData(tutorData.data);
			} else {
				const isValidAll = validateAll();
				if (!isValidAll) return;

				await updateUserData(userData.data);
			}
		});
	};

	const commonAutocompleteStyles = {
		'.MuiOutlinedInput-notchedOutline': {
			border: '2px solid #0146C6 !important',
			fontSize: '1.2vmax',
			borderRadius: '2vmax',
			color: 'var(--primary-font-color) !important',
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#0146C6',
			borderRadius: '2vmax',
			opacity: '1',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#0146C6',
			borderRadius: '2vmax',
		},
		'.MuiInputLabel-outlined': {
			fontFamily: 'PoppinsSemiBold !important',
			fontSize: '1vmax !important',
			// color: "var(--primary-font-color) !important",
			color: 'black !important',
			opacity: 0.5,
		},
		'.MuiInputLabel-shrink': {
			marginLeft: '0.5vmax !important',
			opacity: '1 !important',
			fontSize: '0.85vmax !important',
		},
		'&.Mui-focused': {
			fontFamily: 'PoppinsSemiBold !important',
			fontSize: '0.85vmax !important',
			color: 'var(--primary-font-color) !important',
			marginLeft: '0.5vmax !important',
			opacity: '1',
		},
		'.MuiAutocomplete-input': {
			fontFamily: 'PoppinsSemiBold !important',
			fontSize: '1vmax !important',
			color: 'var(--primary-font-color) !important',
		},
	};

	const commonTextFieldStyles = {
		'& .MuiFormLabel-asterisk': {
			color: 'red',
		},

		'.MuiOutlinedInput-notchedOutline': {
			border: '2px solid #0146C6 !important',
			borderRadius: '2vmax',
		},

		'& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
			border: '2px solid #ccc !important',
		},

		'& .MuiInputBase-input.Mui-disabled': {
			WebkitTextFillColor: '#999 !important',
		},

		'& .MuiInputLabel-root.Mui-disabled': {
			color: '#999 !important',
			opacity: 1,
		},

		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#0146C6',
		},

		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#0146C6',
		},

		'.MuiInputLabel-outlined': {
			fontFamily: 'PoppinsSemiBold !important',
			fontSize: '1vmax !important',
			color: '#000000 !important',
			opacity: 0.5,
		},

		'.MuiInputLabel-shrink': {
			padding: '0 0.5vmax',
			fontSize: '0.85vmax !important',
			color: '#000000 !important',
			opacity: 1,
			backgroundColor: '#fff',
			borderRadius: '4px',
		},
	};

	// const handleLogoClick = () => {
	// 	navigate('/');
	// };

	const getFullName = useCallback(
		(option: any): string => {
			if (!option) return '';

			let first = '';
			let last = '';

			if (type === 'tutor') {
				first = (option as Tutor)?.tutorPersonalDetails?.tutorFirstName ?? '';
				last = (option as Tutor)?.tutorPersonalDetails?.tutorLastName ?? '';
			} else {
				first = (option as Student)?.studentFirstName ?? '';
				last = (option as Student)?.studentLastName ?? '';
			}

			let name = [first.trim(), last.trim()].filter(Boolean).join(' ').trim() || '';

			if (!name) return '';

			if (name.indexOf(' ') === -1 && name.length > 1) {
				const beforeSecondCapital = name.replace(/([a-z])([A-Z])/g, '$1 $2');
				if (beforeSecondCapital !== name) name = beforeSecondCapital;
			}

			return name;
		},
		[type],
	);

	// const autocompleteOptions = useMemo(() => {
	//   const raw = type === "tutor" ? allTutor : allUser;
	//   return Array.isArray(raw) ? raw : [];
	// }, [type, allTutor, allUser]);

	const autocompleteOptions = useMemo(() => {
		const raw = type === 'tutor' ? allTutor : allUser;

		if (!Array.isArray(raw)) return [];

		return [...raw].sort((a: any, b: any) => {
			const nameA = (getFullName(a) || '').trim();
			const nameB = (getFullName(b) || '').trim();

			return nameA.localeCompare(nameB, undefined, {
				sensitivity: 'base',
			});
		});
	}, [type, allTutor, allUser, getFullName]);

	const filterAutocompleteOptions = (opts: any[], { inputValue }: { inputValue: string }) => {
		const query = (inputValue || '').trim().toLowerCase();
		if (!query) return opts;
		return opts.filter((option) => {
			const label = getFullName(option).toLowerCase();
			return label.length > 0 && label.includes(query);
		});
	};

	return (
		<RegistrationPaper>
			<Processing isProceesing={loading} />
			{/* <div className='registration_header'>
				<div className='registration_banner'></div>
				<img className='registration_logo' alt='' src={Logo} onClick={handleLogoClick} />
			</div> */}
			<Navbar />
			{type === 'student' || type === 'tutor' ? (
				<div>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 2,
							mt: 3,
						}}
					>
						{/* <Button
                  variant="contained"
                  sx={{ backgroundColor: "#0146C6", color: "white" }}
                  onClick={editClick}
                >
                  EDIT
                </Button> */}
						<Grid item sx={{ width: 600, ml: 3 }}>
							<Autocomplete
								sx={commonAutocompleteStyles}
								value={selectedUser}
								options={autocompleteOptions}
								loading={loading}
								autoHighlight
								getOptionLabel={(option: any) => getFullName(option)}
								isOptionEqualToValue={(option: any, value: any) => option?.userId != null && option.userId === value?.userId}
								filterOptions={filterAutocompleteOptions}
								onChange={async (_, value) => {
									console.log('value', value);
									setSelectedUser(value);

									if (value === null) {
										setIsNewUser(true);
										setTutorData(initialTutorState);
										setUserData(initialUserState);
										// setStartTime("09:00");
										// setEndTime("18:00");
										// setHasLoadedTutorAvailability(false);
										// setShowTimeRangeWarning(false);
										// setPendingTimeRange(null);
										return;
									}

									if (!value) return;

									await withLoading(async () => {
										if (userRole === 'tutor') {
											const tutorId = value.userId;
											const result = await apiQuery(`registration/tutor/${tutorId}`, {}, 'GET', {});
											setIsNewUser(false);
											setUpdateTutorInfo(result);
										} else {
											const studentId = value.userId;
											const result = await apiQuery(`registration/${studentId}`, {}, 'GET', {});
											setIsNewUser(false);
											setUpdateUserInfo(result);
										}
									});
								}}
								renderOption={(props, option, state) => {
									const inputValue = state?.inputValue ?? '';
									const name = getFullName(option) || String(option?.userId ?? '');
									let matches = match(name, inputValue);
									if (matches.length <= 0 && inputValue.length > 0) {
										const startIndex = name.toLowerCase().indexOf(inputValue.toLowerCase());
										if (startIndex >= 0) {
											matches = [[startIndex, startIndex + inputValue.length] as [number, number]];
										}
									}
									const parts = parse(name, matches);
									const { key, ...restProps } = props;
									return (
										<li key={option?.userId ?? key} {...restProps}>
											<Box>
												{parts.map((part: any, index: number) => (
													<span
														key={index}
														style={{
															color: part.highlight ? '#0146c7' : 'inherit',
															fontWeight: part.highlight ? 700 : 400,
														}}
													>
														{part.text}
													</span>
												))}
											</Box>
										</li>
									);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label={type === 'tutor' ? 'SELECT TUTOR' : 'SELECT STUDENT'}
										InputProps={{
											...params.InputProps,
											endAdornment: (
												<>
													{/* {loading ? "Loading..." : null} */}
													{params.InputProps.endAdornment}
												</>
											),
										}}
									/>
								)}
							/>
						</Grid>

						<Button variant='contained' sx={{ backgroundColor: '#0146C6', color: 'white' }} onClick={addClick}>
							Clear
						</Button>
					</Box>
				</div>
			) : (
				''
			)}
			<div className='registration_content'>
				<Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
					{userRole !== 'tutor' && type !== 'student' && (
						<Grid item xs={3}>
							<Grid container direction={'column'} alignItems={'center'} spacing={2}>
								<Grid item xs>
									<Typography className='registration_welcome'>Hello! {userData.data.studentFirstName}</Typography>
								</Grid>
								<Grid item xs>
									<Typography className='registration_summary'>Help Us To Understand You Better</Typography>
								</Grid>
								<Grid item xs style={{ marginTop: '20%' }}>
									<img className='registration_left_img' alt='' src={RegistrationImg} />
								</Grid>
							</Grid>
						</Grid>
					)}
					{userRole !== 'tutor' && type !== 'student' && <Grid item xs={1}></Grid>}
					<Grid item xs sx={{ padding: '25px' }}>
						<Stack direction={'column'} spacing={2}>
							<Accordion expanded={expanded === 'panel1'} onChange={handleChangeExpand('panel1')}>
								<AccordionSummary className='reg_accordian_summary' aria-controls='panel1d-content' id='panel1d-header'>
									<Typography className='reg_accordian_header'>
										{userRole === 'tutor' ? 'PERSONAL DETAILS' : 'STUDENT DETAILS'}
										<span className='reg_accordian_asterisk'>*</span>
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<br />
									<Grid container direction={'row'} spacing={2}>
										<Grid item xs>
											<CustomTextField
												label='FIRST NAME'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorFirstName' : 'studentFirstName'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorFirstName : userData.error.studentFirstName}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorFirstName : userData.data.studentFirstName}
												onChange={handleChange}
											/>
										</Grid>
										<Grid item xs>
											<CustomTextField
												label='LAST NAME'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorLastName' : 'studentLastName'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorLastName : userData.error.studentLastName}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorLastName : userData.data.studentLastName}
												onChange={handleChange}
											/>
										</Grid>
										<Grid item xs>
											<CustomTextField
												label='E-Mail'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorEmail' : 'studentEmail'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorEmail : userData.error.studentEmail}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.tutorEmail : userData.errorMessage.studentEmail}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorEmail : userData.data.studentEmail}
												onChange={handleChange}
												disabled={selectedUser !== null || !admin}
											/>
										</Grid>
										<Grid item xs={1}>
											<CustomTextField
												label='DIAL CODE'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorPhCode' : 'studentPhCode'}
												type='text'
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorPhCode : userData.error.studentPhCode}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorPhCode : userData.data.studentPhCode}
												onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
													event.preventDefault();
													handleChangeNumber(event, 'dialCode');
												}}
											/>
										</Grid>
										<Grid item xs>
											<CustomTextField
												label='CELL NUMBER'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorCellNumber' : 'studentCellNumber'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorCellNumber : userData.error.studentCellNumber}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.tutorCellNumber : userData.errorMessage.studentCellNumber}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorCellNumber : userData.data.studentCellNumber}
												onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
													event.preventDefault();
													handleChangeNumber(event, 'phone');
												}}
											/>
											{/* <PhoneInput
											    specialLabel='STUDENT CELL NUMBER'
												country={"us"}
												// enableSearch={true}
												value={userData.data.studentCellNumber}
												onChange={(phone) => setPhone(phone)}
												inputProps={{
													name: 'phone',
													required: true
												  }}
											      inputStyle={{
													borderRadius:"50px",
													width:"100%",
													border: "2px solid #0146C6",
													color: 'var(--primary-font-color)',
													fontFamily: 'PoppinsSemiBold'
												  }}
												  containerStyle={{
													color: 'var(--primary-font-color)',
													fontFamily: 'PoppinsSemiBold'
												  }}
											/> */}
										</Grid>
									</Grid>
									<br/>
									{userRole === 'student' && (
										<>
										<Grid container direction={"row"} spacing={2}>
											<Grid item xs={2.75}>
												<CustomTextField
													label="REFFERED BY"
													name={
													userRole === 'student'
													? "studentReferredBy"
													: ""
													}
													type="text"

													value={
													userRole === 'student'
													? userData.data.studentReferredBy
													: ""
													}
													onChange={handleChange}
												/>
											</Grid>
										</Grid>
										</>
									)}
									<br />
									<Grid container direction={'row'} spacing={2}>
										<Grid item xs>
											<Typography className='reg_section_header'>ADDRESS DETAILS:</Typography>
										</Grid>
									</Grid>
									<br />
									<Grid container direction={'row'} spacing={2}>
										<Grid item xs>
											<CustomTextField
												label='ADDRESS 1'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorAddress1' : 'studentAddress1'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorAddress1 : userData.error.studentAddress1}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorAddress1 : userData.data.studentAddress1}
												onChange={handleChange}
											/>
										</Grid>
										<Grid item xs>
											<CustomTextField label='ADDRESS 2' name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorAddress2' : 'studentAddress2'} type='text' value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorAddress2 : userData.data.studentAddress2} onChange={handleChange} />
										</Grid>
										<Grid item xs>
											<CustomTextField
												label='CITY'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorCity' : 'studentCity'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorCity : userData.error.studentCity}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorCity : userData.data.studentCity}
												onChange={handleChange}
											/>
										</Grid>
									</Grid>
									<br />
									<Grid container direction={'row'} spacing={2}>
										<Grid item xs={4}>
											<CustomTextField
												label='STATE/PROVINCE/REGION'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorState' : 'studentState'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorState : userData.error.studentState}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorState : userData.data.studentState}
												onChange={handleChange}
											/>
										</Grid>
										<Grid item xs={4}>
											<CustomTextField
												label='POST OFFICE CODE'
												name={userRole === 'tutor' ? 'tutorPersonalDetails.tutorPostCode' : 'studentPostCode'}
												type='text'
												required
												error={userRole === 'tutor' ? tutorData.error.tutorPersonalDetails.tutorPostCode : userData.error.studentPostCode}
												helperText={userRole === 'tutor' ? tutorData.errorMessage.required : userData.errorMessage.required}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorPostCode : userData.data.studentPostCode}
												onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
													event.preventDefault();
													handleChangeNumber(event, 'none');
												}}
											/>
										</Grid>
										<Grid item xs={4}>
											<Autocomplete
												id='studentCountry'
												sx={commonAutocompleteStyles}
												value={userRole === 'tutor' ? tutorData.data.tutorPersonalDetails.tutorCountry : userData.data.studentCountry}
												options={countryData}
												onChange={(event, value) => {
													handleCountryChange(event, value, userRole === 'tutor' ? 'tutorPersonalDetails.tutorCountry' : 'studentCountry');
												}}
												autoHighlight
												renderInput={(params) => (
													<TextField
														{...params}
														label='COUNTRY'
														required
														sx={{
															'& .MuiFormLabel-asterisk': {
																color: 'red',
															},
														}}
														error={countryError}
														helperText={countryError ? requiredMessage : ''}
													/>
												)}
												renderOption={(props, option: any) => (
													<Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
														<img loading='lazy' width='20' srcSet={option.flag} src={option.flag} alt='flag' />
														{option.label}
													</Box>
												)}
											/>
											<FormHelperText sx={{ color: 'red', marginLeft: 3, display: 'flex' }}>{/* {countryError} */}</FormHelperText>
										</Grid>

										<br />
										{userRole !== 'tutor' && (
											<>
												<Grid item xs={4}>
													<CustomTextField label='GRADE' name='studentGrade' type='text' required error={userData.error.studentGrade} helperText={userData.errorMessage.required} value={userData.data.studentGrade} onChange={handleChange} maxLength={3} />
												</Grid>
												<Grid item xs={4}>
													<CustomDropdownField label='SCHOOL' name='studentSchool' required error={userData.error.studentSchool} helperText={userData.errorMessage.required} value={userData.data.studentSchool} onChange={handleSelectChange}>
														<MenuItem value=''>
															<em>Not Listed</em>
														</MenuItem>
														{(schools || []).map((school: any) => (
															<MenuItem key={school.id} value={school.id}>
																{school.attributes.name}
															</MenuItem>
														))}
													</CustomDropdownField>
												</Grid>
											</>
										)}
										{userRole !== 'tutor' ? (
											<Grid item xs={4} sx={{ display: 'flex', alignItems: 'flex-start' }}>
												<Stack direction={'column'} spacing={0}>
													<CustomCheckBox label='Allow SMS Notification' name='allowsms' alignment='left' checked={userData.data.allowsms} onChange={handleNotification} />
													<Typography className='registration_policy'>By checking this box you agree to receive text messages from AlphaPrep, LLC, you can reply stop to opt-out at any time.</Typography>
													<Typography className='registration_policy'>
														<a href='/privacy-policy' target='_blank'>
															Our Privacy Policy
														</a>
													</Typography>
												</Stack>
											</Grid>
										) : (
											<Grid item xs sx={{ display: 'flex', alignItems: 'flex-start' }}>
												<Stack direction={'column'} spacing={0}>
													<CustomCheckBox
														label='PORTAL ACCESS'
														name='tutorPersonalDetails.IPAccess'
														alignment='left'
														checked={tutorData.data.tutorPersonalDetails.IPAccess}
														onChange={handleChangeCheckbox}
														// onChange={handleNotification}
													/>
												</Stack>
											</Grid>
										)}
									</Grid>
								</AccordionDetails>
							</Accordion>
							{userRole !== 'tutor' && (
								<Accordion expanded={expanded === 'panel2'} onChange={handleChangeExpand('panel2')}>
									<AccordionSummary className='reg_accordian_summary' aria-controls='panel2d-content' id='panel2d-header'>
										<Typography className='reg_accordian_header'>
											PARENT 1 DETAILS
											<span className='reg_accordian_asterisk'>*</span>
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<br />
										<Grid container direction={'row'} spacing={2}>
											<Grid item xs>
												<CustomTextField label='PARENT FIRST NAME' name='parent1FirstName' type='text' required error={userData.error.parent1FirstName} helperText={userData.errorMessage.required} value={userData.data.parent1FirstName} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField label='PARENT LAST NAME' name='parent1LastName' type='text' required error={userData.error.parent1LastName} helperText={userData.errorMessage.required} value={userData.data.parent1LastName} onChange={handleChange} />
											</Grid>
											<Grid item xs={2}>
												<CustomTextField
													label='DIAL CODE'
													name='parent1PhCode'
													type='text'
													error={userData.error.parent1PhCode}
													helperText={userData.errorMessage.required}
													value={userData.data.parent1PhCode}
													onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
														event.preventDefault();
														handleChangeNumber(event, 'dialCode');
													}}
												/>
											</Grid>
											<Grid item xs>
												<CustomTextField
													label='PARENT CELL NUMBER'
													name='parent1CellNumber'
													type='text'
													required
													error={userData.error.parent1CellNumber}
													helperText={userData.errorMessage.parent1CellNumber}
													value={userData.data.parent1CellNumber}
													onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
														event.preventDefault();
														handleChangeNumber(event, 'phone');
													}}
												/>
											</Grid>
											<Grid item xs>
												<CustomTextField label='PARENT EMAIL ADDRESS' name='parent1EmailAddress' type='text' required error={userData.error.parent1EmailAddress} helperText={userData.errorMessage.parent1EmailAddress} value={userData.data.parent1EmailAddress} onChange={handleChange} />
											</Grid>
										</Grid>
										<br />
										<Grid container direction={'column'} spacing={2}>
											<Grid item xs>
												<Typography className='reg_section_header'>ADDRESS DETAILS:</Typography>
											</Grid>
											<Grid item xs>
												<CustomCheckBox label='Same As Student Details' name='parent1SameAsStudent' alignment='left' checked={userData.data.parent1SameAsStudent} onChange={handleChangeCheckbox} />
											</Grid>
										</Grid>
										<br />
										<Grid container direction={'row'} spacing={2}>
											<Grid item xs>
												<CustomTextField
													label='PARENT ADDRESS 1'
													name='parent1Address1'
													type='text'
													required
													disabled={userData.data.parent1SameAsStudent}
													error={userData.error.parent1Address1}
													helperText={userData.errorMessage.required}
													value={userData.data.parent1Address1}
													onChange={handleChange}
												/>
											</Grid>
											<Grid item xs>
												<CustomTextField label='PARENT ADDRESS 2' name='parent1Address2' type='text' disabled={userData.data.parent1SameAsStudent} error={userData.error.parent1Address2} helperText={userData.errorMessage.required} value={userData.data.parent1Address2} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField label='CITY' name='parent1City' type='text' required error={userData.error.parent1City} disabled={userData.data.parent1SameAsStudent} helperText={userData.errorMessage.required} value={userData.data.parent1City} onChange={handleChange} />
											</Grid>
										</Grid>
										<br />
										<Grid container direction={'row'} spacing={2}>
											<Grid item xs>
												<CustomTextField label='STATE/PROVINCE/REGION' name='parent1State' type='text' required disabled={userData.data.parent1SameAsStudent} error={userData.error.parent1State} helperText={userData.errorMessage.required} value={userData.data.parent1State} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField
													label='POST OFFICE CODE'
													name='parent1PostCode'
													type='text'
													required
													disabled={userData.data.parent1SameAsStudent}
													error={userData.error.parent1PostCode}
													helperText={userData.errorMessage.required}
													value={userData.data.parent1PostCode}
													onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
														event.preventDefault();
														handleChangeNumber(event, 'none');
													}}
												/>
											</Grid>
											<Grid item xs>
												<Autocomplete
													id='parent1Country'
													sx={commonAutocompleteStyles}
													value={userData.data.parent1Country}
													disabled={userData.data.parent1SameAsStudent}
													options={countryData}
													onChange={(event, value) => {
														handleCountryChange(event, value, 'parent1Country');
													}}
													autoHighlight
													renderInput={(params) => (
														<TextField
															{...params}
															label='COUNTRY'
															required
															sx={{
																'& .MuiFormLabel-asterisk': {
																	color: 'red',
																},
															}}
														/>
													)}
													renderOption={(props, option: any) => (
														<Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
															<img loading='lazy' width='20' srcSet={option.flag} src={option.flag} alt='flag' />
															{option.label}
														</Box>
													)}
												/>
												<FormHelperText
													sx={{
														color: 'red',
														marginLeft: 3,
														display: 'flex',
													}}
												>
													{userData.error.parent1Country ? userData.errorMessage.required : ''}
												</FormHelperText>
											</Grid>
										</Grid>
									</AccordionDetails>
								</Accordion>
							)}
							{userRole !== 'tutor' && (
								<Accordion expanded={expanded === 'panel3'} onChange={handleChangeExpand('panel3')}>
									<AccordionSummary className='reg_accordian_summary' aria-controls='panel3d-content' id='panel3d-header'>
										<Typography className='reg_accordian_header'>PARENT 2 DETAILS</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<br />
										<Grid container direction={'row'} spacing={2}>
											<Grid item xs>
												<CustomTextField label='PARENT FIRST NAME' name='parent2FirstName' type='text' value={userData.data.parent2FirstName} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField label='PARENT LAST NAME' name='parent2LastName' type='text' value={userData.data.parent2LastName} onChange={handleChange} />
											</Grid>
											<Grid item xs={2}>
												<CustomTextField
													label='DIAL CODE'
													name='parent2PhCode'
													type='text'
													error={userData.error.parent2PhCode}
													helperText={userData.errorMessage.required}
													value={userData.data.parent2PhCode}
													onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
														event.preventDefault();
														handleChangeNumber(event, 'dialCode');
													}}
												/>
											</Grid>
											<Grid item xs>
												<CustomTextField
													label='PARENT CELL NUMBER'
													name='parent2CellNumber'
													type='text'
													error={userData.error.parent2CellNumber}
													helperText={userData.errorMessage.parent2CellNumber}
													value={userData.data.parent2CellNumber}
													onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
														event.preventDefault();
														handleChangeNumber(event, 'phone');
													}}
												/>
											</Grid>
											<Grid item xs>
												<CustomTextField label='PARENT EMAIL ADDRESS' name='parent2EmailAddress' type='text' error={userData.error.parent2EmailAddress} helperText={userData.errorMessage.parent2EmailAddress} value={userData.data.parent2EmailAddress} onChange={handleChange} />
											</Grid>
										</Grid>
										<br />
										<Grid container direction={'column'} spacing={2}>
											<Grid item xs>
												<Typography className='reg_section_header'>ADDRESS DETAILS:</Typography>
											</Grid>
											<Grid item xs>
												<CustomCheckBox label='Same As Student Details' name='parent2SameAsStudent' alignment='left' checked={userData.data.parent2SameAsStudent} onChange={handleChangeCheckbox} />
											</Grid>
										</Grid>
										<br />
										<Grid container direction={'row'} spacing={2}>
											<Grid item xs>
												<CustomTextField label='PARENT ADDRESS 1' name='parent2Address1' type='text' disabled={userData.data.parent2SameAsStudent} value={userData.data.parent2Address1} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField label='PARENT ADDRESS 2' name='parent2Address2' type='text' disabled={userData.data.parent2SameAsStudent} value={userData.data.parent2Address2} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField label='CITY' name='parent2City' type='text' disabled={userData.data.parent2SameAsStudent} value={userData.data.parent2City} onChange={handleChange} />
											</Grid>
										</Grid>
										<br />
										<Grid container direction={'row'} spacing={2}>
											<Grid item xs>
												<CustomTextField label='STATE/PROVINCE/REGION' name='parent2State' type='text' disabled={userData.data.parent2SameAsStudent} value={userData.data.parent2State} onChange={handleChange} />
											</Grid>
											<Grid item xs>
												<CustomTextField
													label='POST OFFICE CODE'
													name='parent2PostCode'
													type='text'
													disabled={userData.data.parent2SameAsStudent}
													value={userData.data.parent2PostCode}
													onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
														event.preventDefault();
														handleChangeNumber(event, 'none');
													}}
												/>
											</Grid>
											<Grid item xs>
												<Autocomplete
													id='parentCountry'
													disabled={userData.data.parent2SameAsStudent}
													sx={commonAutocompleteStyles}
													value={userData.data.parent2Country}
													options={countryData}
													onChange={(event, value) => {
														handleCountryChange(event, value, 'parent2Country');
													}}
													autoHighlight
													renderInput={(params) => <TextField {...params} label='COUNTRY' />}
													renderOption={(props, option: any) => (
														<Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
															<img loading='lazy' width='20' srcSet={option.flag} src={option.flag} alt='flag' />
															{option.label}
														</Box>
													)}
												/>
											</Grid>
										</Grid>
									</AccordionDetails>
								</Accordion>
							)}
							{/* <Accordion expanded={expanded === 'panel4'} onChange={handleChangeExpand('panel4')}>
								<AccordionSummary className='reg_accordian_summary' aria-controls='panel4d-content' id='panel4d-header'>
									<Typography className='reg_accordian_header'>PAYMENT DETAILS</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<br />
									<Grid container direction={'row'} spacing={2}>
										<Grid item xs={6}>
											<CustomTextField
												label='CREDIT CARD NO'
												name='creditCardNum'
												type='text'
												error={userData.error.creditCardNum}
												helperText={userData.errorMessage.creditCardNum}
												value={userData.data.creditCardNum}
												onChange={(event: React.ChangeEvent<HTMLInputElement>, ...rest: any[]) => {
													event.preventDefault();
													handleChangeNumber(event, 'none');
												}}
											/>
										</Grid>
										<Grid item xs>
											<CustomDropdownField
												label='EXPIRATION MONTH'
												name='expirationMonth'
												// error={userData.error.expirationMonth}
												// helperText={userData.errorMessage.required}
												value={userData.data.expirationMonth}
												onChange={handleSelectChange}
											>
												{(expMonths || []).map((mnth: any, idx) => (
													<MenuItem key={idx} value={mnth.id}>
														{`${mnth.name} (${idx + 1})`}
													</MenuItem>
												))}
											</CustomDropdownField>
										</Grid>
										<Grid item xs>
											<CustomDropdownField
												label='EXPIRATION YEAR'
												name='expirationYear'
												// error={userData.error.expirationYear}
												// helperText={userData.errorMessage.required}
												value={userData.data.expirationYear}
												onChange={handleSelectChange}
											>
												{(expYears || []).map((year: any, idx) => (
													<MenuItem key={idx} value={year.id}>
														{year.name}
													</MenuItem>
												))}
											</CustomDropdownField>
										</Grid>
									</Grid>
									<br />
									<Grid container direction={'column'} spacing={2}>
										<Grid item xs>
											<Typography className='reg_section_header'>BILLING ADDRESS</Typography>
										</Grid>
									</Grid>
									<br />
									<Grid container direction={'row'} spacing={2}>
										<Grid item xs>
											<CustomTextField label='NAME ON ACCOUNT' name='nameOnAccount' type='text' value={userData.data.nameOnAccount} onChange={handleChange} />
										</Grid>
										<Grid item xs>
											<Autocomplete
												id='paymentCountry'
												sx={commonAutocompleteStyles}
												value={userData.data.payCountry}
												options={countryData}
												onChange={(event, value) => {
													handleCountryChange(event, value, 'payCountry');
												}}
												autoHighlight
												renderInput={(params) => (
													<TextField
														{...params}
														label='COUNTRY'
														sx={{
															'& .MuiFormLabel-asterisk': {
																color: 'red',
															},
														}}
													/>
												)}
												renderOption={(props, option: any) => (
													<Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
														<img loading='lazy' width='20' srcSet={option.flag} src={option.flag} alt='flag' />
														{option.label}
													</Box>
												)}
											/>
										</Grid>
									</Grid>
								</AccordionDetails>
							</Accordion> */}

							{userRole === 'tutor' && (
								<>
									<Accordion expanded={expanded === 'panel4'} onChange={handleChangeExpand('panel4')}>
										<AccordionSummary className='reg_accordian_summary' aria-controls='panel4d-content' id='panel4d-header'>
											<Typography className='reg_accordian_header'>
												PROFESSIONAL DETAILS
												<span className='reg_accordian_asterisk'>*</span>
											</Typography>
										</AccordionSummary>
										<AccordionDetails>
											<br />
											<Grid container direction={'row'} spacing={2}>
												<Grid item xs={4}>
													<CustomTextField
														label='HIGHEST QUALIFICATION'
														name='tutorProfessionalDetails.tutorHighestQualification'
														type='text'
														required
														error={tutorData.error.tutorProfessionalDetails.tutorHighestQualification}
														helperText={tutorData.errorMessage.required}
														value={tutorData.data.tutorProfessionalDetails.tutorHighestQualification}
														onChange={handleChange}
													/>
												</Grid>

												<Grid item xs={4}>
													<CustomTextField
														label='YEARS OF EXPERIENCE'
														name='tutorProfessionalDetails.tutorYearsOfExperience'
														type='text'
														required
														InputProps={{ inputMode: 'decimal' }}
														error={tutorData.error.tutorProfessionalDetails.tutorYearsOfExperience}
														helperText={tutorData.errorMessage.required}
														value={tutorData.data.tutorProfessionalDetails.tutorYearsOfExperience}
														onChange={(e) => handleChangeYearsOfExperience(e, 'tutorYearsOfExperience')}
													/>
												</Grid>
												<Grid item xs={4}>
													<Autocomplete
														id='tutorTeachingMode'
														sx={commonAutocompleteStyles}
														value={tutorData.data.tutorProfessionalDetails.tutorTeachingMode || null}
														options={techingModeOptions}
														onChange={(_, value) => handleAutocompleteChange(value, 'tutorProfessionalDetails.tutorTeachingMode')}
														autoHighlight
														renderInput={(params) => (
															<TextField
																{...params}
																label='TEACHING MODE'
																required
																sx={{
																	'& .MuiFormLabel-asterisk': { color: 'red' },
																}}
																error={tutorData?.error?.tutorProfessionalDetails?.tutorTeachingMode}
																helperText={tutorData?.error?.tutorProfessionalDetails?.tutorTeachingMode ? tutorData?.errorMessage?.required : ''}
															/>
														)}
													/>
												</Grid>
												<Grid item xs={6}>
													<CustomDropdownMultiSelect
														label='SUBJECTS OF EXPERTISE'
														name='tutorProfessionalDetails.tutorSubjectsExpertise'
														value={tutorData.data.tutorProfessionalDetails.tutorSubjectsExpertise || []}
														options={tutorSubjectOption}
														onChange={(selectedValues) =>
															setTutorData((prev) => ({
																...prev,
																data: {
																	...prev.data,
																	tutorProfessionalDetails: {
																		...prev.data.tutorProfessionalDetails,
																		tutorSubjectsExpertise: selectedValues,
																	},
																},
															}))
														}
													/>
												</Grid>

												<Grid item xs={6}>
													<Autocomplete
														id='tutorPosition'
														sx={commonAutocompleteStyles}
														value={tutorData.data.tutorProfessionalDetails.tutorPosition || null}
														options={tutorPositionOption}
														onChange={(_, value) => handleAutocompleteChange(value, 'tutorProfessionalDetails.tutorPosition')}
														autoHighlight
														renderInput={(params) => (
															<TextField
																{...params}
																label='TUTOR POSITION'
																required
																sx={{
																	'& .MuiFormLabel-asterisk': { color: 'red' },
																}}
																error={tutorData?.error?.tutorProfessionalDetails?.tutorPosition}
																helperText={tutorData?.error?.tutorProfessionalDetails?.tutorPosition ? tutorData?.errorMessage?.required : ''}
															/>
														)}
													/>
												</Grid>

												{/* <Grid item xs>
                          <Typography
                            sx={{
                              fontFamily: "PoppinsSemiBold",
                              fontSize: "1vmax",
                              color: "var(--primary-font-color)",
                              opacity: 0.5,
                              fontWeight: 400,
                              ml: 1,
                            }}
                          >
                            SCHEDULING PREFERENCE
                          </Typography>
                          <br />

                          <Grid item xs>
                            <Stack
                              direction="row"
                              spacing={4}
                              alignItems="center"
                              flexWrap="wrap" 
                            >
                              <Box
                                display="flex"
                                gap={3}
                                flexWrap="wrap"
                                width="50%"
                                
                              >
                                {daysShort.map((day) => (
                                  <IconButton
                                    key={day.value}
                                    onClick={() => {
                                      setActiveDay(day.value);

                                      setTutorData((prev) => {
                                        const existingSlots =
                                          prev.data.tutorAvailability
                                            .availableSlots;

                                        const dayExists = existingSlots.find(
                                          (slot) => slot.day === day.value,
                                        );

                                        let updatedSlots;

                                        if (dayExists) {
                                          updatedSlots = existingSlots.filter(
                                            (slot) => slot.day !== day.value,
                                          );
                                        } else {
                                          updatedSlots = [
                                            ...existingSlots,
                                            {
                                              day: day.value,
                                              timing: [
                                                {
                                                  startTime: startTime,
                                                  endTime: endTime,
                                                },
                                              ],
                                            },
                                          ];
                                        }

                                        return {
                                          ...prev,
                                          data: {
                                            ...prev.data,
                                            tutorAvailability: {
                                              ...prev.data.tutorAvailability,
                                              availableSlots: updatedSlots,
                                            },
                                          },
                                        };
                                      });
                                    }}
                                    sx={{
                                      width: 45,
                                      height: 45,
                                      borderRadius: "50%",
                                      fontWeight: 600,
                                      border: "1px solid #d1d1d1",
                                      backgroundColor:
                                        tutorData.data.tutorAvailability.availableSlots.some(
                                          (slot) => slot.day === day.value,
                                        )
                                          ? "#0146c7"
                                          : "#f5f5f5",
                                      color:
                                        tutorData.data.tutorAvailability.availableSlots.some(
                                          (slot) => slot.day === day.value,
                                        )
                                          ? "#fff"
                                          : "#1e1e1e",
                                    }}
                                    disabled={!tutorData.data.isActive}
                                  >
                                    {day.label}
                                  </IconButton>
                                ))}
                                
                              </Box>
                                
                            <Grid item xs={2}>
                              <TextField
                              sx={commonTextFieldStyles}
                              type="time"
                              label="Start Time"
                              disabled={!tutorData.data.isActive}
                              value={startTime || slots[0]?.timing?.[0]?.startTime}
                              InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                            const value = e.target.value;
                            const currentEndTime = endTime || slots[0]?.timing?.[0]?.endTime || "";

                            if (currentEndTime && value >= currentEndTime) {
                              setStartTimeError(true)
                              setStartTimeErrorMessage("Start time must be earlier than End time");
                              return;
                            }
                            
                            setStartTimeError(false);
                            setStartTimeErrorMessage("");
                            confirmAndApplyTimeRange(value, currentEndTime);
                              }}
                              error={startTimeError}
                              helperText={startTimeErrorMessage}
                            />
                            </Grid>

                          <Grid item xs={2}>
                              <TextField
                                sx={commonTextFieldStyles}
                                type="time"
                                label="End Time"
                                disabled={!tutorData.data.isActive}
                                value={endTime || slots[0]?.timing?.[0]?.endTime}
                                InputLabelProps={{ shrink: true }}
                              //  onChange={(e) => {
                              //   const value = e.target.value;
                              //   setEndTime(value);

                              //   if (!activeDay) return;

                              //   updateTime(activeDay, "endTime", value);
                              // }}
                              onChange={(e) => {
                                const value = e.target.value;
                                const currentStartTime = startTime || slots[0]?.timing?.[0]?.startTime || "";

                                if (currentStartTime && value <= currentStartTime) {
                                  setEndTimeError(true)
                                  setEndTimeErrorMessage("End time must be later than Start time");
                                  return;
                                }
                                
                                setEndTimeError(false);
                                setEndTimeErrorMessage("");
                                confirmAndApplyTimeRange(currentStartTime, value);
                              }}
                              error={endTimeError}
                              helperText={endTimeErrorMessage}

                            />
                          </Grid>

                          {showTimeRangeWarning && (
                            <Grid item xs={12}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 2,
                                  border: "1px solid #f5c2c7",
                                  backgroundColor: "#fff5f5",
                                  borderRadius: "10px",
                                  marginTop: '10px', 
                                  ml: -3.5,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: "PoppinsRegular",
                                    fontSize: "0.95rem",
                                    color: "#842029",
                                    mb: 1.5,
                                  }}
                                >
                                  TimeRange is already booked. Do you want to reset or update the previous TimeRange?
                                </Typography>
                                <Box display="flex" gap={1.5}>
                                  <Button
                                    variant="contained"
                                    onClick={handleTimeRangeWarningOk}
                                    sx={{
                                      textTransform: "none",
                                      backgroundColor: "#0146c7",
                                      "&:hover": { backgroundColor: "#022f86" },
                                    }}
                                  >
                                    OK
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    onClick={handleTimeRangeWarningCancel}
                                    sx={{ textTransform: "none" }}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              </Paper>
                            </Grid>
                          )}

                            </Stack>
                          </Grid>
                        </Grid> */}
											</Grid>
										</AccordionDetails>
									</Accordion>

									{/* <Accordion
                    expanded={expanded === "panel6"}
                    onChange={handleChangeExpand("panel6")}
                  >
                    <AccordionSummary
                      className="reg_accordian_summary"
                      aria-controls="panel6d-content"
                      id="panel6d-header"
                    >
                      <Typography className="reg_accordian_header">
                        PRICING DETAILS
                        <span className="reg_accordian_asterisk">*</span>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <br />
                      <Grid container direction={"row"} spacing={2}>
                        <Grid item xs>
                          <CustomTextField
                            label="CURRENCY"
                            name="tutorCurrency"
                            type="text"
                            value={
                              tutorData.data.tutorPricingDetails.tutorCurrency ?? "USD"
                            }
                            onChange={handleChange}
                            disabled={true}
                          />
                          <FormHelperText
                            sx={{
                              color: "red",
                              marginLeft: 3,
                              display: "flex",
                            }}
                          >
                            
                          </FormHelperText>
                        </Grid>

                        <Grid item xs>
                          <CustomTextField
                            label="RATE"
                            name="tutorRate"
                            type="number"
                            InputProps={{ step: "0.01", min: 0 }}
                            value={
                              tutorData.data.tutorPricingDetails.tutorRate ?? ""
                            }
                            onChange={handleChangeRate}
                            // disabled={userRole === "tutor" ? true : false}
                          />
                        </Grid>

                        <Grid item xs>
                          <Autocomplete
                            id="tutorRateFrequency"
                            sx={commonAutocompleteStyles}
                            value={
                              tutorData.data.tutorPricingDetails.tutorRateFrequency || null
                            }
                            options={rateFrequencyOption}
                           onChange={(_, value) =>
                              handleAutocompleteChange(
                                value,
                                "tutorPricingDetails.tutorRateFrequency"
                              )
                            }
                            autoHighlight
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="RATE FREQUENCY"
                                required
                                sx={{
                                  "& .MuiFormLabel-asterisk": { color: "red" },
                                }}
                                error={
                                  tutorData?.error?.tutorPricingDetails.tutorRateFrequency
                                }
                                helperText={
                                  tutorData?.error?.tutorPricingDetails.tutorRateFrequency
                                    ? tutorData?.errorMessage?.required
                                    : ""
                                }
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <br />
                      <Grid container direction={"row"} spacing={2}>
                        <Grid item xs={12}>
                          <Typography className="reg_section_header">
                            BANK DETAILS:
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <CustomTextField
                            label="ACCOUNT HOLDER NAME"
                            name="tutorPricingDetails.tutorBankDetails.accountHolderName"
                            type="text"
                            required
                            error={
                              tutorData.error.tutorPricingDetails
                                .tutorBankDetails.accountHolderName
                            }
                            helperText={tutorData.errorMessage.required}
                            value={
                              tutorData.data.tutorPricingDetails
                                .tutorBankDetails.accountHolderName
                            }
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <CustomTextField
                            label="BANK NAME"
                            name="tutorPricingDetails.tutorBankDetails.bankName"
                            required
                            // error={tutorData.error.expirationMonth}
                            // helperText={tutorData.errorMessage.required}
                            value={
                              tutorData.data.tutorPricingDetails
                                .tutorBankDetails.bankName
                            }
                            onChange={handleSelectChange}
                            error={
                              tutorData.error.tutorPricingDetails
                                .tutorBankDetails.bankName
                            }
                            helperText={tutorData.errorMessage.required}
                          ></CustomTextField>
                        </Grid>
                        <Grid item xs={4}>
                          <CustomTextField
                            label="ACCOUNT NUMBER"
                            name="tutorPricingDetails.tutorBankDetails.accountNumber"
                            required
                            // error={tutorData.error.expirationMonth}
                            // helperText={tutorData.errorMessage.required}
                            value={
                              tutorData.data.tutorPricingDetails
                                .tutorBankDetails.accountNumber
                            }
                            onChange={handleSelectChange}
                            error={
                              tutorData.error.tutorPricingDetails
                                .tutorBankDetails.accountNumber
                            }
                            helperText={tutorData.errorMessage.required}
                          ></CustomTextField>
                        </Grid>
                      </Grid>
                      <br />
                    </AccordionDetails>
                  </Accordion> */}
								</>
							)}
							<Stack justifyContent={'center'} alignItems={'center'}>
								<CustomButton variant='contained' onClick={saveUserData}>
									{selectedUser === null ? 'Save' : 'Update'}
								</CustomButton>
							</Stack>
						</Stack>
					</Grid>
					{/* <Grid item sx={{    padding: '25px'}}></Grid> */}
					{/* {tutor && <Grid item xs={1}></Grid>} */}
					{userRole === 'tutor' && (
						<Grid item xs={12} md={3}>
							<Grid
								container
								direction='column'
								alignItems='center'
								spacing={3}
								sx={{
									position: 'relative',
									pt: 8,
									// borderRadius: 3,
									// boxShadow: 3,
									backgroundColor: '#fff',
									pb: 4,
								}}
							>
								<Avatar
									src={tutorData?.data?.profilePicture}
									alt={tutorData?.data?.tutorPersonalDetails?.tutorFirstName}
									sx={{
										width: 160,
										height: 160,
										fontSize: 55,
										position: 'absolute',
										top: -120,
										border: '4px solid white',
										boxShadow: 3,
										backgroundColor: '#0146C6',
										color: 'white',
									}}
								>
									{tutorData?.data?.tutorPersonalDetails?.tutorFirstName?.[0]}
								</Avatar>

								<Box sx={{ height: 80 }} />

								<Typography variant='h6' fontWeight={600} textAlign='center'>
									{tutorData?.data?.tutorPersonalDetails?.tutorFirstName} {tutorData?.data?.tutorPersonalDetails?.tutorLastName}
								</Typography>

								<Grid item xs={12}>
									<Stack direction='row' alignItems='center' spacing={2} sx={{ ml: 2, mt: 1 }}>
										<Typography
											sx={{
												fontFamily: 'PoppinsSemiBold',
												fontSize: '1vmax',
												color: userRole === 'tutor' ? 'gray' : 'black',
												fontWeight: 400,
												whiteSpace: 'nowrap',
											}}
										>
											STATUS :
										</Typography>

										<RadioGroup row name='isActive' value={tutorData.data.isActive} onChange={handleRadioChange}>
											<FormControlLabel
												value='true'
												control={<Radio size='small' color='primary' />}
												label='Active'
												sx={{
													'& .MuiFormControlLabel-label': {
														fontFamily: 'PoppinsSemiBold',
														fontSize: '1vmax',
														color: 'black',
													},
												}}
												disabled={!admin}
											/>

											<FormControlLabel
												value='false'
												control={<Radio size='small' color='warning' />}
												label='In Active'
												sx={{
													'& .MuiFormControlLabel-label': {
														fontFamily: 'PoppinsSemiBold',
														fontSize: '1vmax',
														color: 'black',
													},
												}}
												disabled={!admin}
											/>
										</RadioGroup>
									</Stack>
								</Grid>

								<Grid item sx={{ width: '100%', px: 3 }}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DatePicker
											sx={commonTextFieldStyles}
											label='Joined Date'
											value={tutorData?.data?.joinedDate ? dayjs(tutorData.data.joinedDate, 'MM/DD/YYYY') : null}
											format='MM/DD/YYYY'
											onChange={handleJoinedDateChange}
											slotProps={{
												textField: { fullWidth: true, error: tutorData?.error?.joinedDate, helperText: tutorData?.error?.joinedDate ? tutorData?.errorMessage?.joinedDate : '' },
											}}
											disabled={!admin}
										/>
									</LocalizationProvider>
								</Grid>

								<Grid item sx={{ width: '100%', px: 3 }}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DatePicker
											sx={commonTextFieldStyles}
											label='Relieved Date'
											value={tutorData?.data?.relievedDate ? dayjs(tutorData.data.relievedDate, 'MM/DD/YYYY') : null}
											format='MM/DD/YYYY'
											minDate={tutorData?.data?.joinedDate ? dayjs(tutorData.data.joinedDate, 'MM/DD/YYYY') : ''}
											onChange={handleRelievedDateChange}
											slotProps={{
												textField: {
													fullWidth: true,
													error: !tutorData?.data?.isActive && tutorData?.error?.relievedDate,
													helperText: !tutorData?.data?.isActive && tutorData?.error?.relievedDate ? tutorData?.errorMessage?.relievedDate : '',
												},
											}}
											disabled={!admin || (type === 'tutor' && tutorData?.data?.isActive)}
										/>
									</LocalizationProvider>
								</Grid>
							</Grid>
						</Grid>
					)}
					{type === 'student' && (
						<Grid item xs={3} md={3}>
							<Grid container direction='column' spacing={2} sx={{ mt: -20 }}>
								<Grid item xs>
									<Card
										sx={{
											borderRadius: 3,
											boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
											p: 2,
											background: '#F9FAFC',
										}}
									>
										<Typography variant='h6' sx={{ mb: 1, fontWeight: 600 }}>
											<NoteAltIcon sx={{ mb: -1, color: '#0146C6' }} /> Notes
										</Typography>

										<TextField sx={commonTextFieldStyles} multiline name='notes' type='text' minRows={6} fullWidth placeholder='Add internal notes about the student...' inputProps={{ maxLength: 500 }} value={userData.data.notes ? userData?.data?.notes : ''} onChange={handleChange} />

										<Typography variant='caption' sx={{ float: 'right', mt: 1 }}>
											{userData?.data?.notes?.length || 0} / 500
										</Typography>
									</Card>
								</Grid>

								<Grid item xs>
									<Card
										sx={{
											borderRadius: 3,
											boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
											p: 2,
											background: '#F9FAFC',
										}}
									>
										<Typography variant='h6' sx={{ mb: 1, fontWeight: 600 }}>
											<AttachMoneyIcon sx={{ mb: -1, color: '#0146C6' }} /> Deals
										</Typography>

										<TextField sx={commonTextFieldStyles} multiline minRows={6} name='pricing' type='text' fullWidth placeholder='Deals' inputProps={{ maxLength: 500 }} value={userData.data.pricing ? userData?.data?.pricing : ''} onChange={handleChange} disabled />

										<Typography variant='caption' sx={{ float: 'right', mt: 1 }}>
											{userData?.data?.pricing?.length || 0} / 500
										</Typography>
									</Card>
								</Grid>
							</Grid>
						</Grid>
					)}
				</Grid>
			</div>
		</RegistrationPaper>
	);
};

export default Registration;
